import { dummymakler1, dummymakler2, dummymakler3, dummymakler4 } from './demo_makler';

export const similarImmo1Full = {
  id: 14616828,
  tenant_id: 960,
  created_at: '2025-04-09T15:32:47+02:00',
  updated_at: '2025-04-15T09:55:01+02:00',
  published_at: '2025-04-14T14:09:23+02:00',
  catalogue_number: {
    plain: 71796,
    display: '960/71796',
    additionalProperties: {},
  },
  status: {
    id: 5,
    name: 'aktiv',
    until: null,
    additionalProperties: {},
  },
  address: {
    street: null,
    number: null,
    entrance: null,
    door: null,
    zip: null,
    city: null,
    floor: null,
    country: null,
    geo_coordinates: null,
  },
  public_address: {
    street: null,
    number: null,
    entrance: null,
    door: null,
    zip: '2700',
    city: 'Wiener Neustadt',
    country: 'AT',
    geo_coordinates: {
      latitude: 47.7929637,
      longitude: 16.2343567,
      additionalProperties: {},
    },
    fuzzy_geo_coordinates: {
      latitude: 47.81435264,
      longitude: 16.22219976,
      radius: 254,
      additionalProperties: {},
    },
  },
  land_registry_number: null,
  cadastral_municipality: null,
  plot_number: null,
  system_type: 0,
  parent_id: null,
  type: {
    id: 3,
    name: 'Haus',
    openimmo_key: 'haus',
    additionalProperties: {},
  },
  subtype: null,
  occupancy: {
    residential: true,
    commercial: false,
    investment: false,
    additionalProperties: {},
  },
  marketing_type: 0,
  architecture: null,
  year_of_construction: null,
  infrastructure_provision: null,
  year_of_last_renovation: null,
  areas: {
    site_area: null,
    living_area: {
      area: 102,
    },
    floor_area: null,
    developable_area: null,
    office_area: null,
    sales_area: null,
    storage_area: null,
    available_area: null,
    short_term_area: null,
    total_area: null,
    weighted_area: null,
    undeveloped_attic_area: null,
    garden_area: {
      area: 330,
      count: null,
    },
    basement_area: null,
    balcony_area: null,
    terrace_area: null,
    covered_balcony_area: null,
    garage_area: null,
    parking_space_area: {
      area: null,
      count: 1,
    },
  },
  rooms: {
    rooms: 4,
    toilets: 2,
    bathrooms: 2,
    storerooms: null,
  },
  prices: {
    publish_prices: true,
    purchase_price: {
      currency: 'EUR',
      net: 510000,
      gross: 612000,
      vat_absolute: 102000,
      vat_percentage: 20,
    },
    rent: null,
    furniture_hire: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    parking: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    garage: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    operating: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    heating: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    hot_water: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    cooling: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    maintenance_funds: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    elevator: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    others: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
  },
  earnings_per_year: {
    currency: 'EUR',
    net: 0,
    additionalProperties: {},
  },
  obtainable_from: {
    date: '0001-01-01T00:00:00+00:00',
    text: '',
  },
  preview_image: {
    storage_key: '57FrYLOCi1JIxdiVDNqgiP.jpg',
    sizes: {
      original: [],
      fm_small: [],
      medium: [],
    },
  },
  categories: [],
  custom_fields: [],
  agent: {
    id: 16473959,
    prefix: '',
    first_name: dummymakler1.firstName,
    last_name: dummymakler1.lastName,
    gender: 0,
    suffix: 'BA',
    email: `${dummymakler1.firstName.toLowerCase()}.${dummymakler1.lastName.toLowerCase()}@sreal.at`,
    phone: '+43 664 8388745',
    phone_business: '+43 (0)5 0100 - 26261',
    phone_mobile: '+43 664 8388745',
    profile_picture: {
      storage_key: dummymakler1.profilePictureFileId,
      filename: 'dummymakler1.png',
      title: null,
    },
    immobiliencard_id: '',
    immobiliencard_uid: null,
    foreign_id: 33980,
    role: 0,
    permissions: null,
    tenant: {
      id: 960,
      name: 's REAL Immobilienvermittlung GmbH',
      email: 'kundenbetreuung@sreal.at',
      phone: '',
      address: {
        street: 'Landstra\u00DFer Hauptstra\u00DFe 60',
        zip: '1030',
        city: 'Wien',
        country: 'AT',
      },
    },
  },
  active_for_export: true,
  accessible: true,
  contacts: [
    {
      role: 1,
      prospect_state: 0,
      contact: {
        id: 34937626,
        created_at: '2024-09-11T15:30:34+02:00',
        updated_at: '2025-04-08T11:25:06+02:00',
        additionalProperties: {},
      },
    },
  ],
  files: [
    {
      type: 0,
      storage_key: '57FrYLOCi1JIxdiVDNqgiP.jpg',
      url: 'https://storage.justimmo.at/file/57FrYLOCi1JIxdiVDNqgiP.jpg',
      original_filename: 'Wohnhaus.jpg',
      title: 'Wohnhaus',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-04-10T08:43:32+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 868165,
      mime_type: 'image/jpeg',
      width: 1536,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/35b7f1780780846bc384ff3959bbfc69/fc_h300_w100/57FrYLOCi1JIxdiVDNqgiP.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/91c883febb51ec676d61fb143e6db2d7/fc_h1080_w1920/57FrYLOCi1JIxdiVDNqgiP.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/b835c6986603931f2d46f3ced19e7818/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/57FrYLOCi1JIxdiVDNqgiP.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '6rCjojSQ6PUF0hApJkALmo.jpg',
      url: 'https://storage.justimmo.at/file/6rCjojSQ6PUF0hApJkALmo.jpg',
      original_filename: 'K\u00FCche.jpg',
      title: 'K\u00FCche',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-04-10T08:40:28+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 350823,
      mime_type: 'image/jpeg',
      width: 1536,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/b4997a1be3884a9b634082bfef17d9ff/fc_h300_w100/6rCjojSQ6PUF0hApJkALmo.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/461e43ee7cdfd55b742128d713616f7e/fc_h1080_w1920/6rCjojSQ6PUF0hApJkALmo.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/5f7a3c842f31d03157f5b6b57c22f4cd/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/6rCjojSQ6PUF0hApJkALmo.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '5lCCpcA0r3H3fkKQYVlH4l.jpg',
      url: 'https://storage.justimmo.at/file/5lCCpcA0r3H3fkKQYVlH4l.jpg',
      original_filename: 'Badezimmer.jpg',
      title: 'Badezimmer',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-04-10T08:40:17+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 520602,
      mime_type: 'image/jpeg',
      width: 1536,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/3ee39577c6966dcf5cfdf4099e8c0261/fc_h300_w100/5lCCpcA0r3H3fkKQYVlH4l.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/05465d4fd22d88a0bd775a462d927f5d/fc_h1080_w1920/5lCCpcA0r3H3fkKQYVlH4l.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/42507862597bc9783528edf28fb08265/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/5lCCpcA0r3H3fkKQYVlH4l.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '1UvVP0RmWIoii0AUqv0acq.jpg',
      url: 'https://storage.justimmo.at/file/1UvVP0RmWIoii0AUqv0acq.jpg',
      original_filename: 'Wohnzimmer.jpg',
      title: 'Wohnzimmer',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-04-10T08:40:08+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 652670,
      mime_type: 'image/jpeg',
      width: 1536,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/537b55c0cec6c9147c42c1ff3f286406/fc_h300_w100/1UvVP0RmWIoii0AUqv0acq.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/df171080d08c0de0a9e81b00b2282b61/fc_h1080_w1920/1UvVP0RmWIoii0AUqv0acq.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/a8b8d6ac728ca22bd9e98fdfed2a21ea/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/1UvVP0RmWIoii0AUqv0acq.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '558X8lFf5SpIpizNJIvvUN.png',
      url: 'https://storage.justimmo.at/file/558X8lFf5SpIpizNJIvvUN.png',
      original_filename: 'Lageplan.png',
      title: 'Lageplan',
      description: '',
      sort_order: 100000,
      uploaded_at: '2025-04-09T16:16:48+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 315220,
      mime_type: 'image/png',
      width: 2048,
      height: 1360,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/e578cec7a7a16fbd61b45cbd5d458817/fc_h300_w100/558X8lFf5SpIpizNJIvvUN.png',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/84d9140a4e8272688b2c389cbc696ff6/fc_h1080_w1920/558X8lFf5SpIpizNJIvvUN.png',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/c86ed8278fe744430c0e57ba2353b9bd/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/558X8lFf5SpIpizNJIvvUN.png',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '6lmd3tYLNt4yFdZdewKHrW.jpg',
      url: 'https://storage.justimmo.at/file/6lmd3tYLNt4yFdZdewKHrW.jpg',
      original_filename: 'Grundriss OG_0.jpg',
      title: 'Grundriss OG_0',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-04-09T16:16:43+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 233450,
      mime_type: 'image/jpeg',
      width: 950,
      height: 2300,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/e8d70d0ea81857fdbe1238ed7f4768d8/fc_h300_w100/6lmd3tYLNt4yFdZdewKHrW.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/7cb2e1cdcaeb8f6e770ea26df845bf4f/fc_h1080_w1920/6lmd3tYLNt4yFdZdewKHrW.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/4916c8c14baf27bd16a5bd8ad14f364f/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/6lmd3tYLNt4yFdZdewKHrW.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '2kQ77EQGpNXT7j2VGEQNx1.jpg',
      url: 'https://storage.justimmo.at/file/2kQ77EQGpNXT7j2VGEQNx1.jpg',
      original_filename: 'Grundriss EG_0.jpg',
      title: 'Grundriss EG_0',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-04-09T16:16:32+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 268478,
      mime_type: 'image/jpeg',
      width: 986,
      height: 2300,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/f14ad62ffbe0f5dfe4a36cacec80fabe/fc_h300_w100/2kQ77EQGpNXT7j2VGEQNx1.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/983650478fc1914226c532777fb1c23f/fc_h1080_w1920/2kQ77EQGpNXT7j2VGEQNx1.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/c37fd9bfbaa39296eaa4833096dc3b57/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/2kQ77EQGpNXT7j2VGEQNx1.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '5fXhwc9GoYRIk6m8R9VjtH.jpg',
      url: 'https://storage.justimmo.at/file/5fXhwc9GoYRIk6m8R9VjtH.jpg',
      original_filename: 'Grundriss KG_0.jpg',
      title: 'Grundriss KG_0',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-04-09T16:16:26+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 189754,
      mime_type: 'image/jpeg',
      width: 950,
      height: 2300,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/88ef6a8a8c02dc3bfb32fb91a1c249e2/fc_h300_w100/5fXhwc9GoYRIk6m8R9VjtH.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/cdc1ef36a136f1aeb94e2348c75b5ad8/fc_h1080_w1920/5fXhwc9GoYRIk6m8R9VjtH.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/2d964d74adcaa307de4a53eed8abc7db/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/5fXhwc9GoYRIk6m8R9VjtH.jpg',
        },
      ],
      additionalProperties: {},
    },
  ],
  internal_files: [],
  texts: {
    label: '',
    title: [
      {
        value: 'Traumhaus in Wiener Neustadt: 4 Zimmer, Garten, Klimaanlage - Ihr neues Zuhause!',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    location: [
      {
        value: 'Dieses charmante Haus bei 2700 Wiener Neustadt besticht durch seine zentrale Lage in Nieder\u00F6sterreich.',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    description: [
      {
        value:
          '\u003Cp\u003EWillkommen in Ihrem neuen Zuhause in der charmanten Stadt Wiener Neustadt, Nieder\u00F6sterreich! Dieses exquisite Haus bietet Ihnen nicht nur ein modernes Wohnerlebnis, sondern auch eine perfekte Kombination aus Komfort und Funktionalit\u00E4t. Mit einem Kaufpreis von 612.000,00 \u20AC und einer gro\u00DFz\u00FCgigen Wohnfl\u00E4che von 102 m\u00B2 wird Ihr Traum vom Eigenheim wahr.\u003C/p\u003E\r\n\r\n\u003Cp\u003EDie Immobilie verf\u00FCgt \u00FCber insgesamt 4 helle und freundliche Zimmer, die sich ideal f\u00FCr Familien, Paare oder auch als Home-Office eignen. Jedes Zimmer ist so gestaltet, dass Sie sich sofort wohlf\u00FChlen und Ihre pers\u00F6nliche Note einbringen k\u00F6nnen. Der ansprechende Grundriss bietet eine harmonische Verbindung von Wohn- und Lebensraum, die zum Verweilen einl\u00E4dt.\u003C/p\u003E\r\n\r\n\u003Cp\u003EEin Highlight dieses Hauses ist der traumhafte Garten, der Ihnen nicht nur einen R\u00FCckzugsort im Freien bietet, sondern auch Raum f\u00FCr kreative Ideen. Ob Sie den Garten f\u00FCr gesellige Grillabende nutzen oder einfach nur die Ruhe genie\u00DFen m\u00F6chten \u2013 hier k\u00F6nnen Sie sich entfalten. Ein Stellplatz ist ebenfalls vorhanden, sodass Sie sich keine Gedanken \u00FCber Parkm\u00F6glichkeiten machen m\u00FCssen.\u003C/p\u003E\r\n\r\n\u003Cp\u003EDie beiden WCs und B\u00E4der sind modern ausgestattet und bieten Ihnen den Luxus, den Sie sich verdienen. Die Fu\u00DFbodenheizung sorgt f\u00FCr ein angenehmes Raumklima, w\u00E4hrend die Klimaanlage an hei\u00DFen Sommertagen f\u00FCr erfrischende Abk\u00FChlung sorgt. Hochwertige Materialien wie Fliesen und Laminat unterstreichen den eleganten Charakter des Hauses und schaffen eine einladende Atmosph\u00E4re.\u003C/p\u003E\r\n\r\n\u003Cp\u003EGenie\u00DFen Sie den atemberaubenden Gr\u00FCnblick, der Ihnen jeden Tag neue Inspiration und Entspannung bietet. Hier wohnen Sie inmitten der Natur und dennoch in unmittelbarer N\u00E4he zu allen Annehmlichkeiten des urbanen Lebens. Die hervorragende Verkehrsanbindung durch Busverbindungen erm\u00F6glicht Ihnen eine unkomplizierte Mobilit\u00E4t.\u003C/p\u003E\r\n\r\n\u003Cp\u003EIn Ihrer neuen Nachbarschaft finden Sie alles, was das Herz begehrt: \u00C4rzte, Apotheken, Schulen, Superm\u00E4rkte, B\u00E4ckereien und ein Einkaufszentrum sind nur einen Katzensprung entfernt. So haben Sie die M\u00F6glichkeit, Ihren Alltag stressfrei und bequem zu gestalten.\u003C/p\u003E\r\n\r\n\u003Cp\u003EZusammenfassend l\u00E4sst sich sagen, dass dieses Haus in Wiener Neustadt nicht nur ein Ort zum Wohnen ist, sondern ein echtes Zuhause, das Ihnen und Ihrer Familie Sicherheit und Geborgenheit bietet. Lassen Sie sich diese Gelegenheit nicht entgehen! Vereinbaren Sie noch heute einen Besichtigungstermin und erleben Sie selbst die Vorz\u00FCge dieser einzigartigen Immobilie. Ihr neues Zuhause wartet auf Sie!\u003C/p\u003E',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    description_expose: [],
    additionalProperties: {},
  },
  energy_performance_certification: {
    energy_performance: {
      value: 2.33,
      class: 3,
      additionalProperties: {},
    },
    heating_demand: {
      value: 33,
      class: 2,
      additionalProperties: {},
    },
    valid_until: '2028-09-21T00:00:00+00:00',
    auto_disclaimer: false,
    additionalProperties: {},
  },
  features: [
    {
      group_label: 'Boden',
      items: [
        {
          id: 4,
          label: 'Fliesen',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 6,
          label: 'Laminat',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Befeuerung',
      items: [
        {
          id: 13,
          label: 'Gas',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Heizungsart',
      items: [
        {
          id: 18,
          label: 'Fu\u00DFbodenheizung',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Fahrstuhl',
      items: [
        {
          id: 25,
          label: 'Personenaufzug',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bel\u00FCftung',
      items: [
        {
          id: 78,
          label: 'Klimaanlage',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Fenster',
      items: [
        {
          id: 166,
          label: 'Rollladen',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bauweise',
      items: [
        {
          id: 177,
          label: 'Massiv',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Ausblick',
      items: [
        {
          id: 969,
          label: 'Gr\u00FCnblick',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  links: [],
  residential_aggregation_data: null,
  commission: {
    prospect: {
      text_value: null,
    },
  },
  condition_assessment: null,
  is_public: true,
  agency_agreement: {
    valid_from: null,
    valid_until: null,
    agency_agreement_type: 0,
    agreement_method: null,
    additionalProperties: {
      business_opportunity_knowledge_date: null,
    },
  },
  additionalProperties: {
    room_layout: 'centrally_accessible',
    preview_plan: {
      storage_key: [],
      sizes: [[[]], [[]], [[]]],
    },
    year_of_last_comprehensive_renovation: null,
    realty_condition: null,
    building_condition: null,
    vendor_economic_relationship: null,
    dual_brokerage: null,
    automatic_hits: true,
    land_register_entries: [],
    ownership_type: null,
    furnishing: null,
    noise_level: null,
    location_assessment: null,
    floors: {
      count_floors: [],
      count_attic_floors: [],
      mezzanine: [],
    },
  },
};

export const similarImmo1Categories = {
  groups: [
    {
      id: 'traffic',
      name: 'Verkehr',
      categories: [
        {
          id: 'bus',
          name: 'Bus',
          distance: 204,
          additionalProperties: {},
        },
        {
          id: 'motorway_junction',
          name: 'Autobahnanschluss',
          distance: 2028,
          additionalProperties: {},
        },
        {
          id: 'railway_station',
          name: 'Bahnhof',
          distance: 1035,
          additionalProperties: {},
        },
        {
          id: 'aerodrome',
          name: 'Flughafen',
          distance: 2063,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'local_supply',
      name: 'Nahversorgung',
      categories: [
        {
          id: 'supermarket',
          name: 'Supermarkt',
          distance: 546,
          additionalProperties: {},
        },
        {
          id: 'bakery',
          name: 'Bäckerei',
          distance: 434,
          additionalProperties: {},
        },
        {
          id: 'mall',
          name: 'Einkaufszentrum',
          distance: 498,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'other',
      name: 'Sonstige',
      categories: [
        {
          id: 'bank',
          name: 'Bank',
          distance: 302,
          additionalProperties: {},
        },
        {
          id: 'atm',
          name: 'Geldautomat',
          distance: 304,
          additionalProperties: {},
        },
        {
          id: 'police',
          name: 'Polizei',
          distance: 1441,
          additionalProperties: {},
        },
        {
          id: 'post_office',
          name: 'Post',
          distance: 431,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'children_and_school',
      name: 'Kinder & Schulen',
      categories: [
        {
          id: 'school',
          name: 'Schule',
          distance: 592,
          additionalProperties: {},
        },
        {
          id: 'kindergarten',
          name: 'Kindergarten',
          distance: 1096,
          additionalProperties: {},
        },
        {
          id: 'college',
          name: 'Höhere Schule',
          distance: 1871,
          additionalProperties: {},
        },
        {
          id: 'university',
          name: 'Universität',
          distance: 3077,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'health',
      name: 'Gesundheit',
      categories: [
        {
          id: 'doctors',
          name: 'Arzt',
          distance: 887,
          additionalProperties: {},
        },
        {
          id: 'pharmacy',
          name: 'Apotheke',
          distance: 294,
          additionalProperties: {},
        },
        {
          id: 'clinic',
          name: 'Klinik',
          distance: 1825,
          additionalProperties: {},
        },
        {
          id: 'hospital',
          name: 'Krankenhaus',
          distance: 1970,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  additionalProperties: {},
};

export const similarImmo1 = {
  id: 'OBGC20250415080709u1393cim',
  tree_info: {
    name: 'simple',
  },
  crm_id: '14616828',
  number: '960/71796',
  sreal_type_id: 'haus',
  sreal_sub_type_id: 3,
  tenant_id: 960,
  title: {
    de: 'Traumhaus in Wiener Neustadt: 4 Zimmer, Garten, Klimaanlage - Ihr neues Zuhause!',
    en: null,
  },
  address: {
    zip: '2700',
    city: 'Wiener Neustadt',
    federal_state: 'Niederösterreich',
    district: null,
    country: 'AUT',
    street: '',
    door_number: null,
    stair: null,
    house_number: '',
    floor: null,
  },
  buyable: true,
  rentable: false,
  price: {
    currency: 'EUR',
    commission: {
      obligated: true,
      text: {
        de: '',
      },
    },
    garage: {
      count: 1,
    },
    purchase: {
      gross: 612000,
    },
    from: 612000,
    to: 612000,
  },
  area: {
    living: 102,
    floor: 102,
    surface: 0,
    cellar: 0,
    from: 102,
    to: 102,
  },
  rooms: 4,
  cover_image: {
    url: 'https://storage.justimmo.at/thumb/91c883febb51ec676d61fb143e6db2d7/fc_h1080_w1920/57FrYLOCi1JIxdiVDNqgiP.jpg',
  },
  tags: {
    tour: false,
    exclusive: false,
    reference: false,
    residential: true,
    commercial: false,
  },
  project_data: null,
};

export const similarImmo2Full = {
  id: 14616822,
  tenant_id: 960,
  created_at: '2025-04-09T15:32:30+02:00',
  updated_at: '2025-04-15T09:58:06+02:00',
  published_at: '2025-04-15T09:58:03+02:00',
  catalogue_number: {
    plain: 71795,
    display: '960/71795',
    additionalProperties: {},
  },
  status: {
    id: 5,
    name: 'aktiv',
    until: null,
    additionalProperties: {},
  },
  address: {
    street: null,
    number: null,
    entrance: null,
    door: null,
    zip: null,
    city: null,
    floor: null,
    country: null,
    geo_coordinates: null,
  },
  public_address: {
    street: null,
    number: null,
    entrance: null,
    door: null,
    zip: '2483',
    city: 'Ebreichsdorf',
    country: 'AT',
    geo_coordinates: {
      latitude: 47.9722624,
      longitude: 16.3969205,
      additionalProperties: {},
    },
    fuzzy_geo_coordinates: {
      latitude: 47.95122386,
      longitude: 16.39965652,
      radius: 1288,
      additionalProperties: {},
    },
  },
  land_registry_number: null,
  cadastral_municipality: null,
  plot_number: null,
  system_type: 0,
  parent_id: null,
  type: {
    id: 3,
    name: 'Haus',
    openimmo_key: 'haus',
    additionalProperties: {},
  },
  subtype: null,
  occupancy: {
    residential: true,
    commercial: false,
    investment: false,
    additionalProperties: {},
  },
  marketing_type: 0,
  architecture: null,
  year_of_construction: null,
  infrastructure_provision: null,
  year_of_last_renovation: null,
  areas: {
    site_area: null,
    living_area: {
      area: 133,
    },
    floor_area: null,
    developable_area: null,
    office_area: null,
    sales_area: null,
    storage_area: null,
    available_area: null,
    short_term_area: null,
    total_area: null,
    weighted_area: null,
    undeveloped_attic_area: null,
    garden_area: {
      area: 560,
      count: 1,
    },
    basement_area: {
      area: null,
      count: 1,
    },
    balcony_area: null,
    terrace_area: null,
    covered_balcony_area: null,
    garage_area: null,
    parking_space_area: {
      area: null,
      count: 1,
    },
  },
  rooms: {
    rooms: 4,
    toilets: 3,
    bathrooms: 2,
    storerooms: 2,
  },
  prices: {
    publish_prices: true,
    purchase_price: {
      currency: 'EUR',
      net: 500000,
      gross: 600000,
      vat_absolute: 100000,
      vat_percentage: 20,
    },
    rent: null,
    furniture_hire: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    parking: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    garage: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    operating: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    heating: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    hot_water: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    cooling: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    maintenance_funds: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    elevator: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    others: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
  },
  earnings_per_year: {
    currency: 'EUR',
    net: 0,
    additionalProperties: {},
  },
  obtainable_from: {
    date: '0001-01-01T00:00:00+00:00',
    text: '',
  },
  preview_image: {
    storage_key: '1MaEP9OANfc9es9OLBi5kI.jpg',
    sizes: {
      original: [],
      fm_small: [],
      medium: [],
    },
  },
  categories: [],
  custom_fields: [],
  agent: {
    id: 16473959,
    prefix: '',
    first_name: dummymakler1.firstName,
    last_name: dummymakler1.lastName,
    gender: 0,
    suffix: 'BA',
    email: `${dummymakler1.firstName.toLowerCase()}.${dummymakler1.lastName.toLowerCase()}@sreal.at`,
    phone: '+43 664 8388745',
    phone_business: '+43 (0)5 0100 - 26261',
    phone_mobile: '+43 664 8388745',
    profile_picture: {
      storage_key: dummymakler1.profilePictureFileId,
      filename: 'dummymakler1.png',
      title: null,
    },
    immobiliencard_id: '',
    immobiliencard_uid: null,
    foreign_id: 33980,
    role: 0,
    permissions: null,
    tenant: {
      id: 960,
      name: 's REAL Immobilienvermittlung GmbH',
      email: 'kundenbetreuung@sreal.at',
      phone: '',
      address: {
        street: 'Landstra\u00DFer Hauptstra\u00DFe 60',
        zip: '1030',
        city: 'Wien',
        country: 'AT',
      },
    },
  },
  active_for_export: true,
  accessible: true,
  contacts: [
    {
      role: 1,
      prospect_state: 0,
      contact: {
        id: 36354988,
        created_at: '2024-12-03T14:54:33+01:00',
        updated_at: '2025-04-09T15:24:29+02:00',
        additionalProperties: {},
      },
    },
  ],
  files: [
    {
      type: 0,
      storage_key: '2P27xJPAG5mOB4eyR9m450.jpg',
      url: 'https://storage.justimmo.at/file/2P27xJPAG5mOB4eyR9m450.jpg',
      original_filename: 'Wohnzimmer.jpg',
      title: 'Wohnzimmer',
      description: '',
      sort_order: 1,
      uploaded_at: '2025-04-10T08:48:35+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 454100,
      mime_type: 'image/jpeg',
      width: 1536,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/3c80d98f302374cea3bd5e24bc6737c1/fc_h300_w100/2P27xJPAG5mOB4eyR9m450.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/0efc36540b03388a5e7f0c4b4f3131df/fc_h1080_w1920/2P27xJPAG5mOB4eyR9m450.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/3ed57be18b9d10da41b20ed3df0ef16b/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/2P27xJPAG5mOB4eyR9m450.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '1MaEP9OANfc9es9OLBi5kI.jpg',
      url: 'https://storage.justimmo.at/file/1MaEP9OANfc9es9OLBi5kI.jpg',
      original_filename: 'Wohnhaus.jpg',
      title: 'Wohnhaus',
      description: '',
      sort_order: 0,
      uploaded_at: '2025-04-10T08:43:23+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 672197,
      mime_type: 'image/jpeg',
      width: 1536,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/cb083fb361e496613d566a9bc7bb74ea/fc_h300_w100/1MaEP9OANfc9es9OLBi5kI.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/70fe06773ce334e9d3508d089f55adda/fc_h1080_w1920/1MaEP9OANfc9es9OLBi5kI.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/ee2e733740772cc867e2a2bfe65ac0ee/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/1MaEP9OANfc9es9OLBi5kI.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '7Ms6wknHHcCBsFSeIZid10.jpg',
      url: 'https://storage.justimmo.at/file/7Ms6wknHHcCBsFSeIZid10.jpg',
      original_filename: 'Badezimmer.jpg',
      title: 'Badezimmer',
      description: '',
      sort_order: 3,
      uploaded_at: '2025-04-10T08:40:56+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 216947,
      mime_type: 'image/jpeg',
      width: 1536,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/fdc043d24a763a97be6c5b8bc1d58229/fc_h300_w100/7Ms6wknHHcCBsFSeIZid10.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/c71e9eb10060544b0a470c244e720817/fc_h1080_w1920/7Ms6wknHHcCBsFSeIZid10.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/8f2f2a5b337120a038f76662ed581626/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/7Ms6wknHHcCBsFSeIZid10.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '28E1Jza17qLMOkG2nRcn5i.jpg',
      url: 'https://storage.justimmo.at/file/28E1Jza17qLMOkG2nRcn5i.jpg',
      original_filename: 'K\u00FCche.jpg',
      title: 'K\u00FCche',
      description: '',
      sort_order: 2,
      uploaded_at: '2025-04-10T08:40:46+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 424683,
      mime_type: 'image/jpeg',
      width: 1536,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/9674ad836f06beb52072c3b7f26662ef/fc_h300_w100/28E1Jza17qLMOkG2nRcn5i.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/d7278579874433361ffa2bf68d282eae/fc_h1080_w1920/28E1Jza17qLMOkG2nRcn5i.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/8abb59c32f61326f7a0da6ccd0eae992/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/28E1Jza17qLMOkG2nRcn5i.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '7JGRFGZEKrmgkKI14pyg9J.jpg',
      url: 'https://storage.justimmo.at/file/7JGRFGZEKrmgkKI14pyg9J.jpg',
      original_filename: 'Plan_KG_gezeichnet.jpg',
      title: 'Plan_KG_gezeichnet',
      description: '',
      sort_order: 3,
      uploaded_at: '2025-04-09T16:17:21+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 157720,
      mime_type: 'image/jpeg',
      width: 2275,
      height: 2300,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/88e6a7160a76f571ad2a48c671797250/fc_h300_w100/7JGRFGZEKrmgkKI14pyg9J.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/b32af611ce8c876f720e53e6e6cb20de/fc_h1080_w1920/7JGRFGZEKrmgkKI14pyg9J.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/7251e232eec8f65cd9d4eac2b25811b1/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/7JGRFGZEKrmgkKI14pyg9J.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '7ltbCdyslhoiQiNLScskLz.jpg',
      url: 'https://storage.justimmo.at/file/7ltbCdyslhoiQiNLScskLz.jpg',
      original_filename: 'Plan_OG_gezeichnet.jpg',
      title: 'Plan_OG_gezeichnet',
      description: '',
      sort_order: 2,
      uploaded_at: '2025-04-09T16:17:16+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 171584,
      mime_type: 'image/jpeg',
      width: 2158,
      height: 2300,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/1bc376afd23b57e53006f0ececc17618/fc_h300_w100/7ltbCdyslhoiQiNLScskLz.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/ce1afeebb0d38ecd38fda8828bc40fad/fc_h1080_w1920/7ltbCdyslhoiQiNLScskLz.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/96956644e1db2cf9528633282ccc59af/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/7ltbCdyslhoiQiNLScskLz.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '7xn8lexcM5sc0NUDVdb5Ph.jpg',
      url: 'https://storage.justimmo.at/file/7xn8lexcM5sc0NUDVdb5Ph.jpg',
      original_filename: 'Plan_EG_gezeichnet.jpg',
      title: 'Plan_EG_gezeichnet',
      description: '',
      sort_order: 1,
      uploaded_at: '2025-04-09T16:17:11+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 228093,
      mime_type: 'image/jpeg',
      width: 2234,
      height: 2300,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/a7f6bac62a29775d8327e4693c4c2854/fc_h300_w100/7xn8lexcM5sc0NUDVdb5Ph.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/77fcfc2287fb90b34523fe801ca295e3/fc_h1080_w1920/7xn8lexcM5sc0NUDVdb5Ph.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/86536b8abde0b561b97309a3ac0ca0f0/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/7xn8lexcM5sc0NUDVdb5Ph.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '2hI8SRxc2WhUokLqKWssDs.png',
      url: 'https://storage.justimmo.at/file/2hI8SRxc2WhUokLqKWssDs.png',
      original_filename: 'Lageplan.png',
      title: 'Lageplan',
      description: '',
      sort_order: 0,
      uploaded_at: '2025-04-09T16:17:06+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 365678,
      mime_type: 'image/png',
      width: 2048,
      height: 1360,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/cb8f5a3bfd6dcbb7f016133dc75e8f3a/fc_h300_w100/2hI8SRxc2WhUokLqKWssDs.png',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/5ec124744d450c3baa3e22567a51b4a2/fc_h1080_w1920/2hI8SRxc2WhUokLqKWssDs.png',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/51fdc8ac91035329eda1ab41e9810b2b/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/2hI8SRxc2WhUokLqKWssDs.png',
        },
      ],
      additionalProperties: {},
    },
  ],
  internal_files: [],
  texts: {
    label: '',
    title: [
      {
        value: 'Traumhaus in Ebreichsdorf: 133m\u00B2, Garten, Fu\u00DFbodenheizung \u2013 Ihr neues Zuhause!',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    location: [
      {
        value: 'Diese charmante Immobilie befindet sich in der idyllischen Gemeinde Ebreichsdorf, Nieder\u00F6sterreich.',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    description: [
      {
        value:
          '\u003Cp\u003EWillkommen in Ihrem neuen Zuhause in der malerischen Gemeinde Ebreichsdorf, einem charmanten Ort in Nieder\u00F6sterreich, wo sich moderne Lebensqualit\u00E4t mit unber\u00FChrter Natur vereint. Diese exklusive Immobilie steht zum Verkauf und bietet Ihnen alles, was Sie sich f\u00FCr ein erf\u00FClltes Leben w\u00FCnschen \u2013 und das zu einem attraktiven Preis von nur 600.000,00 \u20AC.\u003C/p\u003E\r\n\r\n\u003Cp\u003EAuf gro\u00DFz\u00FCgigen 133 m\u00B2 Wohnfl\u00E4che erleben Sie ein durchdachtes Raumkonzept, das sowohl Funktionalit\u00E4t als auch Stil vereint. Das Herzst\u00FCck des Hauses ist die offene und lichtdurchflutete Wohnk\u00FCche, die mit einer hochwertigen Einbauk\u00FCche ausgestattet ist. Hier k\u00F6nnen Sie nicht nur kulinarische K\u00F6stlichkeiten zubereiten, sondern auch unvergessliche Momente mit Familie und Freunden verbringen.\u003C/p\u003E\r\n\r\n\u003Cp\u003EDie Immobilie verf\u00FCgt \u00FCber insgesamt zwei moderne B\u00E4der, die mit Fenster, Badewanne und Dusche ausgestattet sind. Egal, ob Sie sich nach einem entspannenden Bad sehnen oder eine erfrischende Dusche bevorzugen, hier finden Sie den perfekten R\u00FCckzugsort. Drei separate WCs sorgen zudem f\u00FCr zus\u00E4tzlichen Komfort und Privatsph\u00E4re.\u003C/p\u003E\r\n\r\n\u003Cp\u003EF\u00FCr wohlige W\u00E4rme sorgt die Fu\u00DFbodenheizung, die in allen R\u00E4umen installiert ist. An k\u00FChlen Tagen k\u00F6nnen Sie sich an dem gem\u00FCtlichen Heizofen erfreuen, der eine behagliche Atmosph\u00E4re schafft. Der hochwertige Fliesen- und Laminatboden verleiht Ihrem neuen Zuhause nicht nur eine ansprechende Optik, sondern ist auch \u00E4u\u00DFerst pflegeleicht.\u003C/p\u003E\r\n\r\n\u003Cp\u003EEin absolutes Highlight dieser Immobilie ist der traumhafte Garten, der Ihnen nicht nur Platz f\u00FCr Freizeitaktivit\u00E4ten bietet, sondern auch einen atemberaubenden Ausblick auf die umliegenden Berge und die gr\u00FCne Landschaft. Hier k\u00F6nnen Sie entspannen, die Natur genie\u00DFen und Ihre Sinne verw\u00F6hnen lassen \u2013 sei es beim Grillen mit Freunden oder bei einem ruhigen Abend mit einem Glas Wein.\u003C/p\u003E\r\n\r\n\u003Cp\u003EDie hervorragende Verkehrsanbindung mit Bus und Bahnhof sorgt daf\u00FCr, dass Sie sowohl die Ruhe der Natur als auch die Annehmlichkeiten der Stadt in unmittelbarer N\u00E4he haben. Ob Sie zur Arbeit pendeln oder einen Ausflug ins Umland planen, hier sind Sie ideal angebunden.\u003C/p\u003E\r\n\r\n\u003Cp\u003EEbreichsdorf bietet zudem eine ausgezeichnete Infrastruktur: In der N\u00E4he finden Sie alles, was das Herz begehrt \u2013 von \u00C4rzten \u00FCber Kinderg\u00E4rten und Schulen bis hin zu Superm\u00E4rkten. Hier haben Sie alles, was Sie f\u00FCr das t\u00E4gliche Leben ben\u00F6tigen, in greifbarer N\u00E4he.\u003C/p\u003E\r\n\r\n\u003Cp\u003ELassen Sie sich diese einmalige Gelegenheit nicht entgehen! Dieses Haus in Ebreichsdorf ist der perfekte Ort f\u00FCr Familien, Paare oder Menschen, die Ruhe und Natur sch\u00E4tzen. Treten Sie ein in Ihr zuk\u00FCnftiges Zuhause und erleben Sie Lebensqualit\u00E4t in einem der sch\u00F6nsten Teile Nieder\u00F6sterreichs. Wir freuen uns darauf, Ihnen diese Immobilie pers\u00F6nlich vorzustellen!\u003C/p\u003E',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    description_expose: [],
    additionalProperties: {},
  },
  energy_performance_certification: {
    energy_performance: {
      value: 2.33,
      class: 3,
      additionalProperties: {},
    },
    heating_demand: {
      value: 33,
      class: 2,
      additionalProperties: {},
    },
    valid_until: '2028-09-21T00:00:00+00:00',
    auto_disclaimer: false,
    additionalProperties: {},
  },
  features: [
    {
      group_label: 'Boden',
      items: [
        {
          id: 4,
          label: 'Fliesen',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 6,
          label: 'Laminat',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Heizungsart',
      items: [
        {
          id: 18,
          label: 'Fu\u00DFbodenheizung',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 19,
          label: 'Heizofen',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'K\u00FCche',
      items: [
        {
          id: 22,
          label: 'Einbauk\u00FCche',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bad',
      items: [
        {
          id: 33,
          label: 'Bad mit Fenster',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 34,
          label: 'Badewanne',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 35,
          label: 'Dusche',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bel\u00FCftung',
      items: [
        {
          id: 78,
          label: 'Klimaanlage',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Befeuerung',
      items: [
        {
          id: 93,
          label: 'Luftw\u00E4rmepumpe',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'WCs',
      items: [
        {
          id: 163,
          label: 'Getrennte Toiletten',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 167,
          label: 'G\u00E4ste-WC',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Fenster',
      items: [
        {
          id: 166,
          label: 'Rollladen',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bauweise',
      items: [
        {
          id: 177,
          label: 'Massiv',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Ausblick',
      items: [
        {
          id: 661,
          label: 'Bergblick',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 969,
          label: 'Gr\u00FCnblick',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  links: [],
  residential_aggregation_data: null,
  commission: {
    prospect: {
      text_value: null,
    },
  },
  condition_assessment: null,
  is_public: true,
  agency_agreement: {
    valid_from: null,
    valid_until: null,
    agency_agreement_type: 0,
    agreement_method: null,
    additionalProperties: {
      business_opportunity_knowledge_date: null,
    },
  },
  additionalProperties: {
    room_layout: null,
    preview_plan: {
      storage_key: [],
      sizes: [[[]], [[]], [[]]],
    },
    year_of_last_comprehensive_renovation: null,
    realty_condition: null,
    building_condition: null,
    vendor_economic_relationship: null,
    dual_brokerage: null,
    automatic_hits: true,
    land_register_entries: [],
    ownership_type: null,
    furnishing: null,
    noise_level: null,
    location_assessment: null,
    floors: {
      count_floors: [],
      count_attic_floors: [],
      mezzanine: [],
    },
  },
};

export const similarImmo2Categories = {
  groups: [
    {
      id: 'traffic',
      name: 'Verkehr',
      categories: [
        {
          id: 'bus',
          name: 'Bus',
          distance: 363,
          additionalProperties: {},
        },
        {
          id: 'railway_station',
          name: 'Bahnhof',
          distance: 396,
          additionalProperties: {},
        },
        {
          id: 'motorway_junction',
          name: 'Autobahnanschluss',
          distance: 3277,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'local_supply',
      name: 'Nahversorgung',
      categories: [
        {
          id: 'supermarket',
          name: 'Supermarkt',
          distance: 488,
          additionalProperties: {},
        },
        {
          id: 'bakery',
          name: 'Bäckerei',
          distance: 1189,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'other',
      name: 'Sonstige',
      categories: [
        {
          id: 'bank',
          name: 'Bank',
          distance: 1101,
          additionalProperties: {},
        },
        {
          id: 'atm',
          name: 'Geldautomat',
          distance: 1101,
          additionalProperties: {},
        },
        {
          id: 'post_office',
          name: 'Post',
          distance: 1170,
          additionalProperties: {},
        },
        {
          id: 'police',
          name: 'Polizei',
          distance: 942,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'children_and_school',
      name: 'Kinder & Schulen',
      categories: [
        {
          id: 'kindergarten',
          name: 'Kindergarten',
          distance: 558,
          additionalProperties: {},
        },
        {
          id: 'school',
          name: 'Schule',
          distance: 899,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'health',
      name: 'Gesundheit',
      categories: [
        {
          id: 'doctors',
          name: 'Arzt',
          distance: 658,
          additionalProperties: {},
        },
        {
          id: 'pharmacy',
          name: 'Apotheke',
          distance: 1265,
          additionalProperties: {},
        },
        {
          id: 'clinic',
          name: 'Klinik',
          distance: 8666,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  additionalProperties: {},
};

export const similarImmo2 = {
  id: 'OBGC2025041508080878cnoczh',
  tree_info: {
    name: 'simple',
  },
  crm_id: '14616822',
  number: '960/71795',
  sreal_type_id: 'haus',
  sreal_sub_type_id: 3,
  tenant_id: 960,
  title: {
    de: 'Traumhaus in Ebreichsdorf: 133m², Garten, Fußbodenheizung – Ihr neues Zuhause!',
    en: null,
  },
  address: {
    zip: '2483',
    city: 'Ebreichsdorf',
    federal_state: 'Niederösterreich',
    district: null,
    country: 'AUT',
    street: '',
    door_number: null,
    stair: null,
    house_number: '',
    floor: null,
  },
  buyable: true,
  rentable: false,
  price: {
    currency: 'EUR',
    commission: {
      obligated: true,
      text: {
        de: '',
      },
    },
    garage: {
      count: 1,
    },
    purchase: {
      gross: 600000,
    },
    from: 600000,
    to: 600000,
  },
  area: {
    living: 133,
    floor: 133,
    surface: 0,
    cellar: 0,
    from: 133,
    to: 133,
  },
  rooms: 4,
  cover_image: {
    url: 'https://storage.justimmo.at/thumb/70fe06773ce334e9d3508d089f55adda/fc_h1080_w1920/1MaEP9OANfc9es9OLBi5kI.jpg',
  },
  tags: {
    tour: false,
    exclusive: false,
    reference: false,
    residential: true,
    commercial: false,
  },
  project_data: null,
};

export const similarImmo3Full = {
  id: 14616819,
  tenant_id: 960,
  created_at: '2025-04-09T15:32:15+02:00',
  updated_at: '2025-04-15T09:59:44+02:00',
  published_at: '2025-04-15T09:59:41+02:00',
  catalogue_number: {
    plain: 71794,
    display: '960/71794',
    additionalProperties: {},
  },
  status: {
    id: 5,
    name: 'aktiv',
    until: null,
    additionalProperties: {},
  },
  address: {
    street: null,
    number: null,
    entrance: null,
    door: null,
    zip: null,
    city: null,
    floor: null,
    country: null,
    geo_coordinates: null,
  },
  public_address: {
    street: null,
    number: null,
    entrance: null,
    door: null,
    zip: '2512',
    city: 'Traiskirchen',
    country: 'AT',
    geo_coordinates: {
      latitude: 47.9951924,
      longitude: 16.2744832,
      additionalProperties: {},
    },
    fuzzy_geo_coordinates: {
      latitude: 48.0039978,
      longitude: 16.27405744,
      radius: 255,
      additionalProperties: {},
    },
  },
  land_registry_number: null,
  cadastral_municipality: null,
  plot_number: null,
  system_type: 0,
  parent_id: null,
  type: {
    id: 2,
    name: 'Wohnung',
    openimmo_key: 'wohnung',
    additionalProperties: {},
  },
  subtype: null,
  occupancy: {
    residential: true,
    commercial: false,
    investment: false,
    additionalProperties: {},
  },
  marketing_type: 0,
  architecture: null,
  year_of_construction: 2023,
  infrastructure_provision: null,
  year_of_last_renovation: null,
  areas: {
    site_area: null,
    living_area: {
      area: 87,
    },
    floor_area: null,
    developable_area: null,
    office_area: null,
    sales_area: null,
    storage_area: null,
    available_area: null,
    short_term_area: null,
    total_area: null,
    weighted_area: null,
    undeveloped_attic_area: null,
    garden_area: null,
    basement_area: null,
    balcony_area: null,
    terrace_area: null,
    covered_balcony_area: null,
    garage_area: {
      area: null,
      count: 1,
    },
    parking_space_area: null,
  },
  rooms: {
    rooms: 4,
    toilets: null,
    bathrooms: null,
    storerooms: null,
  },
  prices: {
    publish_prices: true,
    purchase_price: {
      currency: 'EUR',
      net: 350000,
      gross: 420000,
      vat_absolute: 70000,
      vat_percentage: 20,
    },
    rent: null,
    furniture_hire: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    parking: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    garage: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    operating: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    heating: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    hot_water: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    cooling: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    maintenance_funds: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    elevator: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    others: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
  },
  earnings_per_year: {
    currency: 'EUR',
    net: 0,
    additionalProperties: {},
  },
  obtainable_from: {
    date: '0001-01-01T00:00:00+00:00',
    text: '',
  },
  preview_image: {
    storage_key: '6LNvX5CMwm3X8tZewH5uYw.jpg',
    sizes: {
      original: [],
      fm_small: [],
      medium: [],
    },
  },
  categories: [],
  custom_fields: [],
  agent: {
    id: 16473959,
    prefix: '',
    first_name: dummymakler2.firstName,
    last_name: dummymakler2.lastName,
    gender: 0,
    suffix: 'BA',
    email: `${dummymakler2.firstName.toLowerCase()}.${dummymakler2.lastName.toLowerCase()}@sreal.at`,
    phone: '+43 664 8388745',
    phone_business: '+43 (0)5 0100 - 26261',
    phone_mobile: '+43 664 8388745',
    profile_picture: {
      storage_key: dummymakler2.profilePictureFileId,
      filename: 'dummymakler2.png',
      title: null,
    },
    immobiliencard_id: '',
    immobiliencard_uid: null,
    foreign_id: 33980,
    role: 0,
    permissions: null,
    tenant: {
      id: 960,
      name: 's REAL Immobilienvermittlung GmbH',
      email: 'kundenbetreuung@sreal.at',
      phone: '',
      address: {
        street: 'Landstra\u00DFer Hauptstra\u00DFe 60',
        zip: '1030',
        city: 'Wien',
        country: 'AT',
      },
    },
  },
  active_for_export: true,
  accessible: true,
  contacts: [
    {
      role: 1,
      prospect_state: 0,
      contact: {
        id: 36354988,
        created_at: '2024-12-03T14:54:33+01:00',
        updated_at: '2025-04-09T15:24:29+02:00',
        additionalProperties: {},
      },
    },
  ],
  files: [
    {
      type: 0,
      storage_key: '6LNvX5CMwm3X8tZewH5uYw.jpg',
      url: 'https://storage.justimmo.at/file/6LNvX5CMwm3X8tZewH5uYw.jpg',
      original_filename: 'Wohnhaus.jpg',
      title: 'Wohnhaus',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-04-10T08:43:16+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 816439,
      mime_type: 'image/jpeg',
      width: 1536,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/c2d2dc192f2c50f108c1fbe8deb1c55b/fc_h300_w100/6LNvX5CMwm3X8tZewH5uYw.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/d26695741db0731c417f9fbb7175c6e2/fc_h1080_w1920/6LNvX5CMwm3X8tZewH5uYw.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/e7ad9e357626385f99dfdf7ddaf5cda4/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/6LNvX5CMwm3X8tZewH5uYw.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '7ehLLIqC7f5dKkAL47jXVg.jpg',
      url: 'https://storage.justimmo.at/file/7ehLLIqC7f5dKkAL47jXVg.jpg',
      original_filename: 'Wohnzimmer.jpg',
      title: 'Wohnzimmer',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-04-10T08:41:24+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 330133,
      mime_type: 'image/jpeg',
      width: 1536,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/0b84680dfe8f571fea993b27c1a28d8a/fc_h300_w100/7ehLLIqC7f5dKkAL47jXVg.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/280243ff14e8238729723edc64c28e21/fc_h1080_w1920/7ehLLIqC7f5dKkAL47jXVg.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/636605627d250801d3d78a7baa57ca5b/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/7ehLLIqC7f5dKkAL47jXVg.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '612P7RUsoDDXYt6K5O9OO7.jpg',
      url: 'https://storage.justimmo.at/file/612P7RUsoDDXYt6K5O9OO7.jpg',
      original_filename: 'Schlafzimmer.jpg',
      title: 'Schlafzimmer',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-04-10T08:41:14+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 379551,
      mime_type: 'image/jpeg',
      width: 1536,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/dd062abe191cf71b586bb1cf4bc0b02f/fc_h300_w100/612P7RUsoDDXYt6K5O9OO7.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/796375c320166f735ea9d33180ffdfdb/fc_h1080_w1920/612P7RUsoDDXYt6K5O9OO7.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/ca33e5962c63e72e80a201f714d9e1ca/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/612P7RUsoDDXYt6K5O9OO7.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '5G1UDpuAz2y2jPifLpsfce.jpg',
      url: 'https://storage.justimmo.at/file/5G1UDpuAz2y2jPifLpsfce.jpg',
      original_filename: 'K\u00FCche.jpg',
      title: 'K\u00FCche',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-04-10T08:41:08+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 296306,
      mime_type: 'image/jpeg',
      width: 1536,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/59ae98ca97cf6d67f0cce43cdb52023c/fc_h300_w100/5G1UDpuAz2y2jPifLpsfce.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/1f0fa899dfcae7a45a4b941a7fffe31a/fc_h1080_w1920/5G1UDpuAz2y2jPifLpsfce.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/4df1aaae413f97160839cdf31bb3d307/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/5G1UDpuAz2y2jPifLpsfce.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '56yfs0yD0adFIPnmsCOv5l.png',
      url: 'https://storage.justimmo.at/file/56yfs0yD0adFIPnmsCOv5l.png',
      original_filename: 'Lageplan.png',
      title: 'Lageplan',
      description: '',
      sort_order: 100000,
      uploaded_at: '2025-04-09T16:19:12+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 241422,
      mime_type: 'image/png',
      width: 2048,
      height: 1360,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/504acc5d09e7aee9e881567a8353094e/fc_h300_w100/56yfs0yD0adFIPnmsCOv5l.png',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/47776776bc851c54c6c90efa740245ce/fc_h1080_w1920/56yfs0yD0adFIPnmsCOv5l.png',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/c7b4942c6bd3395228409baa84c45535/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/56yfs0yD0adFIPnmsCOv5l.png',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '2BlvL9sOA2yDVERlOk6QHu.jpg',
      url: 'https://storage.justimmo.at/file/2BlvL9sOA2yDVERlOk6QHu.jpg',
      original_filename: 'Plan.jpg',
      title: 'Plan',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-04-09T16:19:02+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 250130,
      mime_type: 'image/jpeg',
      width: 1390,
      height: 2736,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/5f03e43ec597c0d997a769de54c41125/fc_h300_w100/2BlvL9sOA2yDVERlOk6QHu.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/15272c80d2dae36dea7bc07797c6a83b/fc_h1080_w1920/2BlvL9sOA2yDVERlOk6QHu.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/7c1bd46255628d67e63ee6321a80ac43/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/2BlvL9sOA2yDVERlOk6QHu.jpg',
        },
      ],
      additionalProperties: {},
    },
  ],
  internal_files: [],
  texts: {
    label: '',
    title: [
      {
        value: 'Moderne 4-Zimmer-Wohnung in Traiskirchen - Ihr neues Zuhause wartet!',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    location: [
      {
        value: 'Diese attraktive Wohnung in 2512 Traiskirchen besticht durch ihre zentrale Lage und hervorragende Infrastruktur.',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    description: [
      {
        value:
          '\u003Cp\u003EWillkommen in Ihrem neuen Zuhause in der charmanten Stadt Traiskirchen, Nieder\u00F6sterreich! Diese exquisite Wohnung in der 3. Etage bietet Ihnen nicht nur ein modernes und komfortables Wohnerlebnis, sondern auch einen atemberaubenden Ausblick ins Gr\u00FCne, der Ihre Sinne erfreuen wird.\u003C/p\u003E\r\n\r\n\u003Cp\u003EMit einer gro\u00DFz\u00FCgigen Wohnfl\u00E4che von 87 m\u00B2 erstreckt sich diese lichtdurchflutete 4-Zimmer-Wohnung \u00FCber eine durchdachte Raumaufteilung, die Ihnen gen\u00FCgend Platz f\u00FCr Ihre individuellen Wohnbed\u00FCrfnisse bietet. Ob Sie ein gem\u00FCtliches Zuhause f\u00FCr Ihre Familie schaffen m\u00F6chten oder einfach nur eine stilvolle R\u00FCckzugsoase suchen \u2013 hier finden Sie alles, was das Herz begehrt.\u003C/p\u003E\r\n\r\n\u003Cp\u003EDie Wohnung ist mit hochwertigen Materialien ausgestattet, darunter schicke Fliesen und geschmackvolles Laminat. Die Fu\u00DFbodenheizung sorgt f\u00FCr wohlige W\u00E4rme und ein angenehmes Wohnklima, w\u00E4hrend die Klimaanlage an hei\u00DFen Sommertagen f\u00FCr erfrischende Abk\u00FChlung sorgt. Die moderne Einbauk\u00FCche l\u00E4dt zu kulinarischen Abenteuern ein und bietet ausreichend Stauraum f\u00FCr all Ihre Kochutensilien.\u003C/p\u003E\r\n\r\n\u003Cp\u003EEin weiteres Highlight dieser Immobilie ist die Garage, die Ihnen nicht nur einen sicheren Parkplatz bietet, sondern auch zus\u00E4tzlichen Stauraum f\u00FCr Ihre Freizeitutensilien. Der Personenaufzug bringt Sie bequem in die 3. Etage, sodass Sie auch an langen Tagen ganz entspannt nach Hause kommen k\u00F6nnen.\u003C/p\u003E\r\n\r\n\u003Cp\u003EDie Lage dieser Wohnung ist einfach unschlagbar! In unmittelbarer N\u00E4he finden Sie alles, was Sie f\u00FCr den Alltag ben\u00F6tigen: \u00C4rzte, Apotheken, Kindergarten, Schulen und Superm\u00E4rkte sind bequem zu Fu\u00DF erreichbar. Die hervorragende Verkehrsanbindung mit Bus und Bahnhof erm\u00F6glicht es Ihnen, schnell und unkompliziert in die umliegenden St\u00E4dte und Regionen zu gelangen.\u003C/p\u003E\r\n\r\n\u003Cp\u003EGenie\u00DFen Sie die Vorz\u00FCge des Lebens in Traiskirchen, wo Natur und urbanes Leben harmonisch miteinander verschmelzen. Verpassen Sie nicht die Gelegenheit, diese einzigartige Wohnung zu Ihrem neuen Lebensmittelpunkt zu machen! Der Kaufpreis von 420.000,00 \u20AC ist nicht nur eine Investition in Ihre Zukunft, sondern auch in Ihre Lebensqualit\u00E4t.\u003C/p\u003E\r\n\r\n\u003Cp\u003ELassen Sie sich diese Gelegenheit nicht entgehen und vereinbaren Sie noch heute einen Besichtigungstermin! Ihre Traumwohnung wartet auf Sie!\u003C/p\u003E',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    description_expose: [],
    additionalProperties: {},
  },
  energy_performance_certification: {
    energy_performance: {
      value: 2.33,
      class: 3,
      additionalProperties: {},
    },
    heating_demand: {
      value: 33,
      class: 2,
      additionalProperties: {},
    },
    valid_until: '2028-09-21T00:00:00+00:00',
    auto_disclaimer: false,
    additionalProperties: {},
  },
  features: [
    {
      group_label: 'Boden',
      items: [
        {
          id: 4,
          label: 'Fliesen',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 6,
          label: 'Laminat',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Heizungsart',
      items: [
        {
          id: 18,
          label: 'Fu\u00DFbodenheizung',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'K\u00FCche',
      items: [
        {
          id: 22,
          label: 'Einbauk\u00FCche',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Fahrstuhl',
      items: [
        {
          id: 25,
          label: 'Personenaufzug',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Stellplatzart',
      items: [
        {
          id: 46,
          label: 'Parkplatz',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bel\u00FCftung',
      items: [
        {
          id: 78,
          label: 'Klimaanlage',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Befeuerung',
      items: [
        {
          id: 102,
          label: 'Fernw\u00E4rme',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Fenster',
      items: [
        {
          id: 154,
          label: 'Au\u00DFenliegender Sonnenschutz',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 166,
          label: 'Rollladen',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bauweise',
      items: [
        {
          id: 177,
          label: 'Massiv',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Ausblick',
      items: [
        {
          id: 969,
          label: 'Gr\u00FCnblick',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  links: [],
  residential_aggregation_data: null,
  commission: {
    prospect: {
      text_value: null,
    },
  },
  condition_assessment: null,
  is_public: true,
  agency_agreement: {
    valid_from: null,
    valid_until: null,
    agency_agreement_type: 0,
    agreement_method: null,
    additionalProperties: {
      business_opportunity_knowledge_date: null,
    },
  },
  additionalProperties: {
    room_layout: 'centrally_accessible',
    preview_plan: {
      storage_key: [],
      sizes: [[[]], [[]], [[]]],
    },
    year_of_last_comprehensive_renovation: null,
    realty_condition: null,
    building_condition: null,
    vendor_economic_relationship: null,
    dual_brokerage: null,
    automatic_hits: true,
    land_register_entries: [],
    ownership_type: null,
    furnishing: null,
    noise_level: null,
    location_assessment: null,
    floors: {
      count_floors: [],
      count_attic_floors: [],
      mezzanine: [],
    },
  },
};

export const similarImmo3Categories = {
  groups: [
    {
      id: 'traffic',
      name: 'Verkehr',
      categories: [
        {
          id: 'bus',
          name: 'Bus',
          distance: 153,
          additionalProperties: {},
        },
        {
          id: 'railway_station',
          name: 'Bahnhof',
          distance: 561,
          additionalProperties: {},
        },
        {
          id: 'motorway_junction',
          name: 'Autobahnanschluss',
          distance: 1762,
          additionalProperties: {},
        },
        {
          id: 'tram',
          name: 'Straßenbahn',
          distance: 1067,
          additionalProperties: {},
        },
        {
          id: 'aerodrome',
          name: 'Flughafen',
          distance: 4385,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'other',
      name: 'Sonstige',
      categories: [
        {
          id: 'bank',
          name: 'Bank',
          distance: 386,
          additionalProperties: {},
        },
        {
          id: 'atm',
          name: 'Geldautomat',
          distance: 386,
          additionalProperties: {},
        },
        {
          id: 'police',
          name: 'Polizei',
          distance: 1577,
          additionalProperties: {},
        },
        {
          id: 'post_office',
          name: 'Post',
          distance: 1597,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'children_and_school',
      name: 'Kinder & Schulen',
      categories: [
        {
          id: 'kindergarten',
          name: 'Kindergarten',
          distance: 343,
          additionalProperties: {},
        },
        {
          id: 'school',
          name: 'Schule',
          distance: 350,
          additionalProperties: {},
        },
        {
          id: 'college',
          name: 'Höhere Schule',
          distance: 7666,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'health',
      name: 'Gesundheit',
      categories: [
        {
          id: 'doctors',
          name: 'Arzt',
          distance: 323,
          additionalProperties: {},
        },
        {
          id: 'pharmacy',
          name: 'Apotheke',
          distance: 535,
          additionalProperties: {},
        },
        {
          id: 'clinic',
          name: 'Klinik',
          distance: 1781,
          additionalProperties: {},
        },
        {
          id: 'hospital',
          name: 'Krankenhaus',
          distance: 1361,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'local_supply',
      name: 'Nahversorgung',
      categories: [
        {
          id: 'supermarket',
          name: 'Supermarkt',
          distance: 725,
          additionalProperties: {},
        },
        {
          id: 'bakery',
          name: 'Bäckerei',
          distance: 1206,
          additionalProperties: {},
        },
        {
          id: 'mall',
          name: 'Einkaufszentrum',
          distance: 2736,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  additionalProperties: {},
};

export const similarImmo3 = {
  id: 'OBGC20250415080843fa286jf8',
  tree_info: {
    name: 'simple',
  },
  crm_id: '14616819',
  number: '960/71794',
  sreal_type_id: 'wohnung',
  sreal_sub_type_id: 2,
  tenant_id: 960,
  title: {
    de: 'Moderne 4-Zimmer-Wohnung in Traiskirchen - Ihr neues Zuhause wartet!',
    en: null,
  },
  address: {
    zip: '2512',
    city: 'Traiskirchen',
    federal_state: 'Niederösterreich',
    district: null,
    country: 'AUT',
    street: '',
    door_number: null,
    stair: null,
    house_number: '',
    floor: null,
  },
  buyable: true,
  rentable: false,
  price: {
    currency: 'EUR',
    commission: {
      obligated: true,
      text: {
        de: '',
      },
    },
    garage: {
      count: 1,
    },
    purchase: {
      gross: 420000,
    },
    from: 420000,
    to: 420000,
  },
  area: {
    living: 87,
    floor: 87,
    surface: 0,
    cellar: 0,
    from: 87,
    to: 87,
  },
  rooms: 4,
  cover_image: {
    url: 'https://storage.justimmo.at/thumb/d26695741db0731c417f9fbb7175c6e2/fc_h1080_w1920/6LNvX5CMwm3X8tZewH5uYw.jpg',
  },
  tags: {
    tour: false,
    exclusive: false,
    reference: false,
    residential: true,
    commercial: false,
  },
  project_data: null,
};

export const similarImmo4Full = {
  id: 14616813,
  tenant_id: 960,
  created_at: '2025-04-09T15:31:54+02:00',
  updated_at: '2025-04-15T10:01:36+02:00',
  published_at: '2025-04-15T10:01:33+02:00',
  catalogue_number: {
    plain: 71793,
    display: '960/71793',
    additionalProperties: {},
  },
  status: {
    id: 5,
    name: 'aktiv',
    until: null,
    additionalProperties: {},
  },
  address: {
    street: null,
    number: null,
    entrance: null,
    door: null,
    zip: null,
    city: null,
    floor: null,
    country: null,
    geo_coordinates: null,
  },
  public_address: {
    street: null,
    number: null,
    entrance: null,
    door: null,
    zip: '2345',
    city: 'Brunn am Gebirge',
    country: 'AT',
    geo_coordinates: {
      latitude: 48.1135005,
      longitude: 16.3010359,
      additionalProperties: {},
    },
    fuzzy_geo_coordinates: {
      latitude: 48.10569721,
      longitude: 16.27120489,
      radius: 265,
      additionalProperties: {},
    },
  },
  land_registry_number: null,
  cadastral_municipality: null,
  plot_number: null,
  system_type: 0,
  parent_id: null,
  type: {
    id: 3,
    name: 'Haus',
    openimmo_key: 'haus',
    additionalProperties: {},
  },
  subtype: null,
  occupancy: {
    residential: true,
    commercial: false,
    investment: false,
    additionalProperties: {},
  },
  marketing_type: 0,
  architecture: null,
  year_of_construction: null,
  infrastructure_provision: null,
  year_of_last_renovation: null,
  areas: {
    site_area: null,
    living_area: {
      area: 120,
    },
    floor_area: null,
    developable_area: null,
    office_area: null,
    sales_area: null,
    storage_area: null,
    available_area: null,
    short_term_area: null,
    total_area: null,
    weighted_area: null,
    undeveloped_attic_area: null,
    garden_area: {
      area: 500,
      count: 1,
    },
    basement_area: null,
    balcony_area: null,
    terrace_area: {
      area: 35,
      count: 1,
    },
    covered_balcony_area: null,
    garage_area: {
      area: null,
      count: 1,
    },
    parking_space_area: null,
  },
  rooms: {
    rooms: 15,
    toilets: null,
    bathrooms: null,
    storerooms: null,
  },
  prices: {
    publish_prices: true,
    purchase_price: {
      currency: 'EUR',
      net: 520000,
      gross: 624000,
      vat_absolute: 104000,
      vat_percentage: 20,
    },
    rent: null,
    furniture_hire: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    parking: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    garage: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    operating: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    heating: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    hot_water: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    cooling: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    maintenance_funds: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    elevator: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    others: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
  },
  earnings_per_year: {
    currency: 'EUR',
    net: 0,
    additionalProperties: {},
  },
  obtainable_from: {
    date: '0001-01-01T00:00:00+00:00',
    text: '',
  },
  preview_image: {
    storage_key: '2mUCRZhDzTYTHse2DEINU8.jpg',
    sizes: {
      original: [],
      fm_small: [],
      medium: [],
    },
  },
  categories: [],
  custom_fields: [],
  agent: {
    id: 16473959,
    prefix: '',
    first_name: dummymakler3.firstName,
    last_name: dummymakler3.lastName,
    gender: 0,
    suffix: 'BA',
    email: `${dummymakler3.firstName.toLowerCase()}.${dummymakler3.lastName.toLowerCase()}@sreal.at`,
    phone: '+43 664 8388745',
    phone_business: '+43 (0)5 0100 - 26261',
    phone_mobile: '+43 664 8388745',
    profile_picture: {
      storage_key: dummymakler3.profilePictureFileId,
      filename: 'dummymakler3.png',
      title: null,
    },
    immobiliencard_id: '',
    immobiliencard_uid: null,
    foreign_id: 33980,
    role: 0,
    permissions: null,
    tenant: {
      id: 960,
      name: 's REAL Immobilienvermittlung GmbH',
      email: 'kundenbetreuung@sreal.at',
      phone: '',
      address: {
        street: 'Landstra\u00DFer Hauptstra\u00DFe 60',
        zip: '1030',
        city: 'Wien',
        country: 'AT',
      },
    },
  },
  active_for_export: true,
  accessible: true,
  contacts: [
    {
      role: 1,
      prospect_state: 0,
      contact: {
        id: 36354988,
        created_at: '2024-12-03T14:54:33+01:00',
        updated_at: '2025-04-09T15:24:29+02:00',
        additionalProperties: {},
      },
    },
  ],
  files: [
    {
      type: 0,
      storage_key: '2mUCRZhDzTYTHse2DEINU8.jpg',
      url: 'https://storage.justimmo.at/file/2mUCRZhDzTYTHse2DEINU8.jpg',
      original_filename: 'Au\u00DFenansicht.jpg',
      title: 'Au\u00DFenansicht',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-04-10T08:43:08+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 516051,
      mime_type: 'image/jpeg',
      width: 1536,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/4f604ae6ca00c09b5017bdf9cd553e99/fc_h300_w100/2mUCRZhDzTYTHse2DEINU8.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/392e9a5a007b80e086016124cfcfc6a6/fc_h1080_w1920/2mUCRZhDzTYTHse2DEINU8.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/036285b3a2e3d44093adfc9f12177e7c/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/2mUCRZhDzTYTHse2DEINU8.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '2k7nvb125UkobpH6lucBEh.jpg',
      url: 'https://storage.justimmo.at/file/2k7nvb125UkobpH6lucBEh.jpg',
      original_filename: 'Badezimmer.jpg',
      title: 'Badezimmer',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-04-10T08:41:45+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 400143,
      mime_type: 'image/jpeg',
      width: 1536,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/f78bc3d4b41230e920d06e2c0e08a51d/fc_h300_w100/2k7nvb125UkobpH6lucBEh.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/d5ad2eaee8f19a7d22e73f94876d255a/fc_h1080_w1920/2k7nvb125UkobpH6lucBEh.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/9ed185c974a437af8500654074be5cfa/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/2k7nvb125UkobpH6lucBEh.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '5oOCqBJo32LCex71LodRXf.jpg',
      url: 'https://storage.justimmo.at/file/5oOCqBJo32LCex71LodRXf.jpg',
      original_filename: 'Wohnzimmer.jpg',
      title: 'Wohnzimmer',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-04-10T08:41:40+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 437373,
      mime_type: 'image/jpeg',
      width: 1536,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/27266579c2ced7d1b8efce86f2d39ac1/fc_h300_w100/5oOCqBJo32LCex71LodRXf.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/cb4376e3924d34236a0e593c46e7de28/fc_h1080_w1920/5oOCqBJo32LCex71LodRXf.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/63a5b32a1fd86a993675126f26036b7e/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/5oOCqBJo32LCex71LodRXf.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '73HQT2sKvkhoO0ko9aVcBa.jpg',
      url: 'https://storage.justimmo.at/file/73HQT2sKvkhoO0ko9aVcBa.jpg',
      original_filename: 'K\u00FCche.jpg',
      title: 'K\u00FCche',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-04-10T08:41:35+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 318189,
      mime_type: 'image/jpeg',
      width: 1536,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/51da50f91ba7041c72fa598c34581d2e/fc_h300_w100/73HQT2sKvkhoO0ko9aVcBa.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/f9d7ca3e96e833587b2973173edacb64/fc_h1080_w1920/73HQT2sKvkhoO0ko9aVcBa.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/1b0b97454a5e982c24f71e02e61ed41c/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/73HQT2sKvkhoO0ko9aVcBa.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: 'nHcbv4hIPd398lor5Rlq3.png',
      url: 'https://storage.justimmo.at/file/nHcbv4hIPd398lor5Rlq3.png',
      original_filename: 'Lageplan.png',
      title: 'Lageplan',
      description: '',
      sort_order: 100000,
      uploaded_at: '2025-04-09T16:19:37+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 253549,
      mime_type: 'image/png',
      width: 2048,
      height: 1360,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/f2e3a6a09c5b4b887d1d20bab320b56d/fc_h300_w100/nHcbv4hIPd398lor5Rlq3.png',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/f195af2bf3bebc58a9691f1cb96a8fc5/fc_h1080_w1920/nHcbv4hIPd398lor5Rlq3.png',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/6dc4c88c606d4c2fdac88ecd8c01bc9f/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/nHcbv4hIPd398lor5Rlq3.png',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '1xflmAAFSIvlUrdv73v0SN.jpg',
      url: 'https://storage.justimmo.at/file/1xflmAAFSIvlUrdv73v0SN.jpg',
      original_filename: 'Planskizze EG.jpg',
      title: 'Planskizze EG',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-04-09T16:19:32+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 105281,
      mime_type: 'image/jpeg',
      width: 658,
      height: 1080,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/967c8334185300edc814c1ebfa569483/fc_h300_w100/1xflmAAFSIvlUrdv73v0SN.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/9857415e4885d79d0ee4bb35a3ee32a3/fc_h1080_w1920/1xflmAAFSIvlUrdv73v0SN.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/873d662ad9539655d62b3095be656ed3/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/1xflmAAFSIvlUrdv73v0SN.jpg',
        },
      ],
      additionalProperties: {},
    },
  ],
  internal_files: [],
  texts: {
    label: '',
    title: [
      {
        value: 'Traumhaus in Brunn am Gebirge: 120m\u00B2, 15 Zimmer, Garten \u0026 Garage',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    location: [
      {
        value: 'Dieses charmante Haus in 2345 Brunn am Gebirge bietet eine ideale Lage f\u00FCr Familien und Pendler.',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    description: [
      {
        value:
          '\u003Cp\u003EWillkommen in Ihrem neuen Zuhause in Brunn am Gebirge, einer idyllischen Gemeinde in Nieder\u00F6sterreich mit einer perfekten Kombination aus l\u00E4ndlicher Ruhe und st\u00E4dtischer Anbindung!\u003C/p\u003E\r\n\r\n\u003Cp\u003EDieses charmante Haus bietet Ihnen auf gro\u00DFz\u00FCgigen 120 m\u00B2 eine Oase der Lebensqualit\u00E4t. Mit insgesamt 15 Zimmern haben Sie ausreichend Platz f\u00FCr Ihre Familie, G\u00E4ste oder sogar ein Homeoffice. Hier k\u00F6nnen Sie Ihre Wohntr\u00E4ume verwirklichen und den Raum nach Ihren Vorstellungen gestalten.\u003C/p\u003E\r\n\r\n\u003Cp\u003EDer Garten l\u00E4dt zu entspannenden Stunden im Freien ein und bietet Ihnen einen herrlichen Gr\u00FCnblick, der das Herz jedes Naturliebhabers h\u00F6herschlagen l\u00E4sst. Stellen Sie sich vor, wie Sie an warmen Sommertagen im Garten entspannen oder mit Freunden und Familie unvergessliche Grillabende genie\u00DFen. Auch die integrierte Garage und der Carport bieten Ihnen ausreichend Platz f\u00FCr Ihre Fahrzeuge und sch\u00FCtzen diese vor Witterungseinfl\u00FCssen.\u003C/p\u003E\r\n\r\n\u003Cp\u003EIm Inneren des Hauses erwartet Sie eine harmonische Kombination aus modernem Komfort und stilvollem Design. Hochwertige Fliesen und Laminatb\u00F6den sorgen f\u00FCr ein einladendes Ambiente, w\u00E4hrend die Fu\u00DFbodenheizung in den kalten Monaten f\u00FCr wohlige W\u00E4rme sorgt. Die Klimaanlage garantiert Ihnen auch an hei\u00DFen Sommertagen ein angenehmes Raumklima. Deckenleuchten setzen Ihre Wohnr\u00E4ume perfekt in Szene und die Rolll\u00E4den bieten Ihnen sowohl Sichtschutz als auch eine zus\u00E4tzliche Isolierung.\u003C/p\u003E\r\n\r\n\u003Cp\u003EDie Verkehrsanbindung ist hervorragend: Eine Busverbindung bringt Sie schnell in die umliegenden St\u00E4dte und erleichtert Ihnen die Mobilit\u00E4t. Zudem profitieren Sie von einer hervorragenden Infrastruktur in der N\u00E4he. \u00C4rzte, Schulen, Kinderg\u00E4rten, Superm\u00E4rkte und B\u00E4ckereien sind in unmittelbarer Umgebung und sorgen daf\u00FCr, dass Sie alle Annehmlichkeiten des t\u00E4glichen Lebens in kurzer Zeit erreichen k\u00F6nnen.\u003C/p\u003E\r\n\r\n\u003Cp\u003EDer Kaufpreis von 624.000,00 \u20AC bietet Ihnen die M\u00F6glichkeit, in ein Zuhause zu investieren, das sowohl Komfort als auch Lebensqualit\u00E4t in einer der besten Lagen Nieder\u00F6sterreichs vereint.\u003C/p\u003E\r\n\r\n\u003Cp\u003ELassen Sie sich diese einmalige Gelegenheit nicht entgehen! Kontaktieren Sie uns f\u00FCr einen Besichtigungstermin und \u00FCberzeugen Sie sich selbst von diesem wunderbaren Zuhause in Brunn am Gebirge. Ihr Traumhaus wartet auf Sie!\u003C/p\u003E',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    description_expose: [],
    additionalProperties: {},
  },
  energy_performance_certification: {
    energy_performance: {
      value: 2.33,
      class: 3,
      additionalProperties: {},
    },
    heating_demand: {
      value: 33,
      class: 2,
      additionalProperties: {},
    },
    valid_until: '2028-09-21T00:00:00+00:00',
    auto_disclaimer: false,
    additionalProperties: {},
  },
  features: [
    {
      group_label: 'Boden',
      items: [
        {
          id: 4,
          label: 'Fliesen',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 6,
          label: 'Laminat',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Heizungsart',
      items: [
        {
          id: 18,
          label: 'Fu\u00DFbodenheizung',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'K\u00FCche',
      items: [
        {
          id: 23,
          label: 'Wohnk\u00FCche / offene K\u00FCche',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Stellplatzart',
      items: [
        {
          id: 43,
          label: 'Carport',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bel\u00FCftung',
      items: [
        {
          id: 78,
          label: 'Klimaanlage',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Befeuerung',
      items: [
        {
          id: 93,
          label: 'Luftw\u00E4rmepumpe',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Beleuchtung',
      items: [
        {
          id: 161,
          label: 'Deckenleuchten',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Fenster',
      items: [
        {
          id: 166,
          label: 'Rollladen',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bauweise',
      items: [
        {
          id: 177,
          label: 'Massiv',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Ausblick',
      items: [
        {
          id: 969,
          label: 'Gr\u00FCnblick',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  links: [],
  residential_aggregation_data: null,
  commission: {
    prospect: {
      text_value: null,
    },
  },
  condition_assessment: null,
  is_public: true,
  agency_agreement: {
    valid_from: null,
    valid_until: null,
    agency_agreement_type: 0,
    agreement_method: null,
    additionalProperties: {
      business_opportunity_knowledge_date: null,
    },
  },
  additionalProperties: {
    room_layout: 'centrally_accessible',
    preview_plan: {
      storage_key: [],
      sizes: [[[]], [[]], [[]]],
    },
    year_of_last_comprehensive_renovation: null,
    realty_condition: null,
    building_condition: null,
    vendor_economic_relationship: null,
    dual_brokerage: null,
    automatic_hits: true,
    land_register_entries: [],
    ownership_type: null,
    furnishing: null,
    noise_level: null,
    location_assessment: null,
    floors: {
      count_floors: [],
      count_attic_floors: [],
      mezzanine: [],
    },
  },
};

export const similarImmo4Categories = {
  groups: [
    {
      id: 'traffic',
      name: 'Verkehr',
      categories: [
        {
          id: 'bus',
          name: 'Bus',
          distance: 39,
          additionalProperties: {},
        },
        {
          id: 'subway',
          name: 'U-Bahn',
          distance: 3821,
          additionalProperties: {},
        },
        {
          id: 'tram',
          name: 'Straßenbahn',
          distance: 2871,
          additionalProperties: {},
        },
        {
          id: 'railway_station',
          name: 'Bahnhof',
          distance: 1294,
          additionalProperties: {},
        },
        {
          id: 'motorway_junction',
          name: 'Autobahnanschluss',
          distance: 1497,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'health',
      name: 'Gesundheit',
      categories: [
        {
          id: 'doctors',
          name: 'Arzt',
          distance: 552,
          additionalProperties: {},
        },
        {
          id: 'pharmacy',
          name: 'Apotheke',
          distance: 1099,
          additionalProperties: {},
        },
        {
          id: 'clinic',
          name: 'Klinik',
          distance: 2673,
          additionalProperties: {},
        },
        {
          id: 'hospital',
          name: 'Krankenhaus',
          distance: 2001,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'local_supply',
      name: 'Nahversorgung',
      categories: [
        {
          id: 'supermarket',
          name: 'Supermarkt',
          distance: 643,
          additionalProperties: {},
        },
        {
          id: 'bakery',
          name: 'Bäckerei',
          distance: 611,
          additionalProperties: {},
        },
        {
          id: 'mall',
          name: 'Einkaufszentrum',
          distance: 2870,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'children_and_school',
      name: 'Kinder & Schulen',
      categories: [
        {
          id: 'school',
          name: 'Schule',
          distance: 654,
          additionalProperties: {},
        },
        {
          id: 'kindergarten',
          name: 'Kindergarten',
          distance: 600,
          additionalProperties: {},
        },
        {
          id: 'university',
          name: 'Universität',
          distance: 8585,
          additionalProperties: {},
        },
        {
          id: 'college',
          name: 'Höhere Schule',
          distance: 4064,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'other',
      name: 'Sonstige',
      categories: [
        {
          id: 'bank',
          name: 'Bank',
          distance: 931,
          additionalProperties: {},
        },
        {
          id: 'atm',
          name: 'Geldautomat',
          distance: 931,
          additionalProperties: {},
        },
        {
          id: 'post_office',
          name: 'Post',
          distance: 923,
          additionalProperties: {},
        },
        {
          id: 'police',
          name: 'Polizei',
          distance: 1123,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  additionalProperties: {},
};

export const similarImmo4 = {
  id: 'OBGC20250415080914qlb24ha9',
  tree_info: {
    name: 'simple',
  },
  crm_id: '14616813',
  number: '960/71793',
  sreal_type_id: 'haus',
  sreal_sub_type_id: 3,
  tenant_id: 960,
  title: {
    de: 'Traumhaus in Brunn am Gebirge: 120m², 15 Zimmer, Garten & Garage',
    en: null,
  },
  address: {
    zip: '2345',
    city: 'Brunn am Gebirge',
    federal_state: 'Niederösterreich',
    district: null,
    country: 'AUT',
    street: '',
    door_number: null,
    stair: null,
    house_number: '',
    floor: null,
  },
  buyable: true,
  rentable: false,
  price: {
    currency: 'EUR',
    commission: {
      obligated: true,
      text: {
        de: '',
      },
    },
    garage: {
      count: 1,
    },
    purchase: {
      gross: 624000,
    },
    from: 624000,
    to: 624000,
  },
  area: {
    living: 120,
    floor: 120,
    surface: 0,
    cellar: 0,
    from: 120,
    to: 120,
  },
  rooms: 15,
  cover_image: {
    url: 'https://storage.justimmo.at/thumb/392e9a5a007b80e086016124cfcfc6a6/fc_h1080_w1920/2mUCRZhDzTYTHse2DEINU8.jpg',
  },
  tags: {
    tour: false,
    exclusive: false,
    reference: false,
    residential: true,
    commercial: false,
  },
  project_data: null,
};

export const similarImmo5Full = {
  id: 14616810,
  tenant_id: 960,
  created_at: '2025-04-09T15:31:33+02:00',
  updated_at: '2025-04-15T10:02:35+02:00',
  published_at: '2025-04-15T10:02:32+02:00',
  catalogue_number: {
    plain: 71792,
    display: '960/71792',
    additionalProperties: {},
  },
  status: {
    id: 5,
    name: 'aktiv',
    until: null,
    additionalProperties: {},
  },
  address: {
    street: null,
    number: null,
    entrance: null,
    door: null,
    zip: null,
    city: null,
    floor: null,
    country: null,
    geo_coordinates: null,
  },
  public_address: {
    street: null,
    number: null,
    entrance: null,
    door: null,
    zip: '2514',
    city: 'Traiskirchen',
    country: 'AT',
    geo_coordinates: {
      latitude: 48.0213914,
      longitude: 16.3041881,
      additionalProperties: {},
    },
    fuzzy_geo_coordinates: {
      latitude: 48.01378258,
      longitude: 16.28655889,
      radius: 351,
      additionalProperties: {},
    },
  },
  land_registry_number: null,
  cadastral_municipality: null,
  plot_number: null,
  system_type: 0,
  parent_id: null,
  type: {
    id: 3,
    name: 'Haus',
    openimmo_key: 'haus',
    additionalProperties: {},
  },
  subtype: null,
  occupancy: {
    residential: true,
    commercial: false,
    investment: false,
    additionalProperties: {},
  },
  marketing_type: 0,
  architecture: null,
  year_of_construction: 2015,
  infrastructure_provision: null,
  year_of_last_renovation: null,
  areas: {
    site_area: null,
    living_area: {
      area: 98,
    },
    floor_area: null,
    developable_area: null,
    office_area: null,
    sales_area: null,
    storage_area: null,
    available_area: null,
    short_term_area: null,
    total_area: null,
    weighted_area: null,
    undeveloped_attic_area: null,
    garden_area: null,
    basement_area: null,
    balcony_area: null,
    terrace_area: null,
    covered_balcony_area: null,
    garage_area: {
      area: null,
      count: 1,
    },
    parking_space_area: null,
  },
  rooms: {
    rooms: 4,
    toilets: null,
    bathrooms: null,
    storerooms: null,
  },
  prices: {
    publish_prices: true,
    purchase_price: {
      currency: 'EUR',
      net: 420000,
      gross: 504000,
      vat_absolute: 84000,
      vat_percentage: 20,
    },
    rent: null,
    furniture_hire: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    parking: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    garage: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    operating: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    heating: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    hot_water: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    cooling: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    maintenance_funds: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    elevator: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    others: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
  },
  earnings_per_year: {
    currency: 'EUR',
    net: 0,
    additionalProperties: {},
  },
  obtainable_from: {
    date: '0001-01-01T00:00:00+00:00',
    text: '',
  },
  preview_image: {
    storage_key: '5yN157ga9P7qtMPrmckYlS.jpg',
    sizes: {
      original: [],
      fm_small: [],
      medium: [],
    },
  },
  categories: [],
  custom_fields: [],
  agent: {
    id: 16473959,
    prefix: '',
    first_name: dummymakler4.firstName,
    last_name: dummymakler4.lastName,
    gender: 0,
    suffix: 'BA',
    email: `${dummymakler4.firstName.toLowerCase()}.${dummymakler4.lastName.toLowerCase()}@sreal.at`,
    phone: '+43 664 8388745',
    phone_business: '+43 (0)5 0100 - 26261',
    phone_mobile: '+43 664 8388745',
    profile_picture: {
      storage_key: dummymakler4.profilePictureFileId,
      filename: 'dummymakler4.png',
      title: null,
    },
    immobiliencard_id: '',
    immobiliencard_uid: null,
    foreign_id: 33980,
    role: 0,
    permissions: null,
    tenant: {
      id: 960,
      name: 's REAL Immobilienvermittlung GmbH',
      email: 'kundenbetreuung@sreal.at',
      phone: '',
      address: {
        street: 'Landstra\u00DFer Hauptstra\u00DFe 60',
        zip: '1030',
        city: 'Wien',
        country: 'AT',
      },
    },
  },
  active_for_export: true,
  accessible: true,
  contacts: [
    {
      role: 1,
      prospect_state: 0,
      contact: {
        id: 36354988,
        created_at: '2024-12-03T14:54:33+01:00',
        updated_at: '2025-04-09T15:24:29+02:00',
        additionalProperties: {},
      },
    },
  ],
  files: [
    {
      type: 0,
      storage_key: '1wrRWVb4dkjeS9UINU8xMZ.jpg',
      url: 'https://storage.justimmo.at/file/1wrRWVb4dkjeS9UINU8xMZ.jpg',
      original_filename: 'Wohnzimmer.jpg',
      title: 'Wohnzimmer',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-04-10T08:49:04+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 665287,
      mime_type: 'image/jpeg',
      width: 1536,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/8c817361a18b630a318f8e1ea2219944/fc_h300_w100/1wrRWVb4dkjeS9UINU8xMZ.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/4139b6dfdfe401f5fa35f788f4d8df7f/fc_h1080_w1920/1wrRWVb4dkjeS9UINU8xMZ.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/7f193733497342564d2198b26707e81f/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/1wrRWVb4dkjeS9UINU8xMZ.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '5yN157ga9P7qtMPrmckYlS.jpg',
      url: 'https://storage.justimmo.at/file/5yN157ga9P7qtMPrmckYlS.jpg',
      original_filename: 'Au\u00DFenansicht.jpg',
      title: 'Au\u00DFenansicht',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-04-10T08:43:00+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 505647,
      mime_type: 'image/jpeg',
      width: 1536,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/52375dcc6862eb3637db553828d68990/fc_h300_w100/5yN157ga9P7qtMPrmckYlS.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/d085e4e972c399edaab3c5bf03fd42c2/fc_h1080_w1920/5yN157ga9P7qtMPrmckYlS.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/cfc3742fb3b61211c353e18812219692/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/5yN157ga9P7qtMPrmckYlS.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '1zDZHXFnuHzGsZlpnEndKl.jpg',
      url: 'https://storage.justimmo.at/file/1zDZHXFnuHzGsZlpnEndKl.jpg',
      original_filename: 'Badezimmer.jpg',
      title: 'Badezimmer',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-04-10T08:42:19+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 258704,
      mime_type: 'image/jpeg',
      width: 1536,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/363548c5a54aee047b5c89ab2b288f3d/fc_h300_w100/1zDZHXFnuHzGsZlpnEndKl.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/94a8f9b9b0ae9132ea70e0d15cfde616/fc_h1080_w1920/1zDZHXFnuHzGsZlpnEndKl.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/1e6aa724c7a8aab079b6c3c34838cf01/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/1zDZHXFnuHzGsZlpnEndKl.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '6aM1aDVE4WwAaUgeVdfXJo.jpg',
      url: 'https://storage.justimmo.at/file/6aM1aDVE4WwAaUgeVdfXJo.jpg',
      original_filename: 'Schlafzimmer.jpg',
      title: 'Schlafzimmer',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-04-10T08:42:10+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 336216,
      mime_type: 'image/jpeg',
      width: 1536,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/d3fe0734ecbe5da6a64ac5aebb097184/fc_h300_w100/6aM1aDVE4WwAaUgeVdfXJo.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/da89d2f4c5fa63f218e97e13e9ce14b3/fc_h1080_w1920/6aM1aDVE4WwAaUgeVdfXJo.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/e65cf91f8b011637b5f80fd09bdfc053/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/6aM1aDVE4WwAaUgeVdfXJo.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '7fExxCI6lRyCJiz5m38tnN.jpg',
      url: 'https://storage.justimmo.at/file/7fExxCI6lRyCJiz5m38tnN.jpg',
      original_filename: 'K\u00FCche.jpg',
      title: 'K\u00FCche',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-04-10T08:41:59+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 315468,
      mime_type: 'image/jpeg',
      width: 1536,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/2ea0cced08d4dd8b87f859c624306255/fc_h300_w100/7fExxCI6lRyCJiz5m38tnN.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/f8466fd96ed4e89029fa3a937b88c959/fc_h1080_w1920/7fExxCI6lRyCJiz5m38tnN.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/4d21f384e89664493ad323e719146a41/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/7fExxCI6lRyCJiz5m38tnN.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '4908NgAgDCij3M081DrMIY.jpg',
      url: 'https://storage.justimmo.at/file/4908NgAgDCij3M081DrMIY.jpg',
      original_filename: 'Planskizze KG.jpg',
      title: 'Planskizze KG',
      description: '',
      sort_order: 2,
      uploaded_at: '2025-04-09T16:20:15+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 169383,
      mime_type: 'image/jpeg',
      width: 1900,
      height: 2655,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/23eb38f1e358bd7ea88eea055c3c61fc/fc_h300_w100/4908NgAgDCij3M081DrMIY.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/744b4076e9a431b4f3423cfcb5cd00fb/fc_h1080_w1920/4908NgAgDCij3M081DrMIY.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/addcb174f8bec7078690c085b21609be/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/4908NgAgDCij3M081DrMIY.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '1Y4izyXLW8AxDgJPG690YJ.jpg',
      url: 'https://storage.justimmo.at/file/1Y4izyXLW8AxDgJPG690YJ.jpg',
      original_filename: 'Planskizze DG.jpg',
      title: 'Planskizze DG',
      description: '',
      sort_order: 1,
      uploaded_at: '2025-04-09T16:20:07+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 224474,
      mime_type: 'image/jpeg',
      width: 1612,
      height: 3129,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/e2a3a94f9f4f77c1ec0ffcb07b16a698/fc_h300_w100/1Y4izyXLW8AxDgJPG690YJ.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/3c9c7ed18e082279ba87e770efc1e7ca/fc_h1080_w1920/1Y4izyXLW8AxDgJPG690YJ.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/641a948f344442a45259411d55dbe7a1/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/1Y4izyXLW8AxDgJPG690YJ.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '7r9Pg2QkX1gcj8drYjElSD.jpg',
      url: 'https://storage.justimmo.at/file/7r9Pg2QkX1gcj8drYjElSD.jpg',
      original_filename: 'Planskizze EG.jpg',
      title: 'Planskizze EG',
      description: '',
      sort_order: 0,
      uploaded_at: '2025-04-09T16:19:59+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 219065,
      mime_type: 'image/jpeg',
      width: 1827,
      height: 2655,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/c9e7e8f4ed870bdde475dc2b102b2c97/fc_h300_w100/7r9Pg2QkX1gcj8drYjElSD.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/431c741391fc2def59338bbfcdb4b7ff/fc_h1080_w1920/7r9Pg2QkX1gcj8drYjElSD.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/a4db5244d4475140e4c5a7e2e6c12adf/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/7r9Pg2QkX1gcj8drYjElSD.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '1SQ48SzmVCDdQUVogvAAuh.png',
      url: 'https://storage.justimmo.at/file/1SQ48SzmVCDdQUVogvAAuh.png',
      original_filename: 'Lageplan.png',
      title: 'Lageplan',
      description: '',
      sort_order: 3,
      uploaded_at: '2025-04-09T16:19:53+02:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 274285,
      mime_type: 'image/png',
      width: 2048,
      height: 1360,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/01565fb39d30e8808659c30d5118dc26/fc_h300_w100/1SQ48SzmVCDdQUVogvAAuh.png',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/4d2613869d88d8c38149982b7983162d/fc_h1080_w1920/1SQ48SzmVCDdQUVogvAAuh.png',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/cc71eec080ab806da954fc7aeb95f4a1/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/1SQ48SzmVCDdQUVogvAAuh.png',
        },
      ],
      additionalProperties: {},
    },
  ],
  internal_files: [],
  texts: {
    label: '',
    title: [
      {
        value: 'Traumhaus in Traiskirchen: 4 Zimmer, Garage, modernste Ausstattung',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    location: [
      {
        value: 'Dieses charmante Haus in 2514 Traiskirchen besticht durch seine ideale Lage.',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    description: [
      {
        value:
          '\u003Cp\u003EEntdecken Sie Ihr neues Zuhause in der charmanten Stadt Traiskirchen, Nieder\u00F6sterreich! Dieses ansprechende Haus bietet Ihnen die perfekte Kombination aus modernem Wohnkomfort und idyllischer Lage. Mit einem Kaufpreis von 504.000,00 \u20AC erwartet Sie hier ein liebevoll gestaltetes Zuhause, das auf 98 m\u00B2 Wohnfl\u00E4che viel Platz f\u00FCr Ihre individuellen Wohnw\u00FCnsche bietet.\u003C/p\u003E\r\n\r\n\u003Cp\u003EDas Haus verf\u00FCgt \u00FCber insgesamt 4 Zimmer, die sich ideal f\u00FCr Familien oder Paare eignen, die Wert auf Raum und Flexibilit\u00E4t legen. Die durchdachte Raumaufteilung sorgt daf\u00FCr, dass Sie sowohl R\u00FCckzugsm\u00F6glichkeiten als auch gesellige Bereiche finden. Genie\u00DFen Sie den Blick ins Gr\u00FCne, der Ihnen nicht nur Ruhe, sondern auch eine angenehme Atmosph\u00E4re bietet. Hier k\u00F6nnen Sie die Natur in vollen Z\u00FCgen genie\u00DFen und sich vom Alltagsstress erholen.\u003C/p\u003E\r\n\r\n\u003Cp\u003EAusstattungsmerkmale wie Fliesen und Laminat in den Wohnbereichen, Fu\u00DFbodenheizung sowie eine Klimaanlage garantieren Ihnen h\u00F6chsten Wohnkomfort zu jeder Jahreszeit. Ein Personenaufzug sorgt f\u00FCr barrierefreien Zugang und die Rolll\u00E4den bieten zus\u00E4tzlichen Komfort und Sicherheit. Zudem ist das Haus massiv gebaut und bietet Ihnen somit eine solide Grundlage f\u00FCr viele Jahre.\u003C/p\u003E\r\n\r\n\u003Cp\u003EDie praktische Garage rundet das Angebot ab und bietet Ihnen nicht nur Platz f\u00FCr Ihr Fahrzeug, sondern auch Stauraum f\u00FCr Fahrr\u00E4der oder Gartenger\u00E4te.\u003C/p\u003E\r\n\r\n\u003Cp\u003EDie Verkehrsanbindung ist hervorragend: Bus und Bahnhof sind in unmittelbarer N\u00E4he und erm\u00F6glichen Ihnen eine bequeme Anbindung an die umliegenden St\u00E4dte und Gemeinden.\u003C/p\u003E\r\n\r\n\u003Cp\u003EAuch die Infrastruktur l\u00E4sst keine W\u00FCnsche offen. In der Umgebung finden Sie alles, was Sie f\u00FCr den t\u00E4glichen Bedarf ben\u00F6tigen: Arztpraxen, Apotheken, Schulen, Kinderg\u00E4rten, Superm\u00E4rkte, B\u00E4ckereien und ein Einkaufszentrum sind bequem zu erreichen. So sind Sie stets bestens versorgt und k\u00F6nnen das Leben in Traiskirchen in vollen Z\u00FCgen genie\u00DFen.\u003C/p\u003E\r\n\r\n\u003Cp\u003EZ\u00F6gern Sie nicht und vereinbaren Sie noch heute einen Besichtigungstermin! Lassen Sie sich von diesem einzigartigen Angebot begeistern und verwirklichen Sie Ihren Traum vom Eigenheim in Traiskirchen. Ihr neues Zuhause wartet auf Sie!\u003C/p\u003E',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    description_expose: [],
    additionalProperties: {},
  },
  energy_performance_certification: {
    energy_performance: {
      value: 2.33,
      class: 3,
      additionalProperties: {},
    },
    heating_demand: {
      value: 33,
      class: 2,
      additionalProperties: {},
    },
    valid_until: '2028-09-21T00:00:00+00:00',
    auto_disclaimer: false,
    additionalProperties: {},
  },
  features: [
    {
      group_label: 'Boden',
      items: [
        {
          id: 4,
          label: 'Fliesen',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 6,
          label: 'Laminat',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Heizungsart',
      items: [
        {
          id: 18,
          label: 'Fu\u00DFbodenheizung',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'K\u00FCche',
      items: [
        {
          id: 23,
          label: 'Wohnk\u00FCche / offene K\u00FCche',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Fahrstuhl',
      items: [
        {
          id: 25,
          label: 'Personenaufzug',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bel\u00FCftung',
      items: [
        {
          id: 78,
          label: 'Klimaanlage',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Befeuerung',
      items: [
        {
          id: 102,
          label: 'Fernw\u00E4rme',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Fenster',
      items: [
        {
          id: 166,
          label: 'Rollladen',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bauweise',
      items: [
        {
          id: 177,
          label: 'Massiv',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Ausblick',
      items: [
        {
          id: 969,
          label: 'Gr\u00FCnblick',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  links: [],
  residential_aggregation_data: null,
  commission: {
    prospect: {
      text_value: null,
    },
  },
  condition_assessment: null,
  is_public: true,
  agency_agreement: {
    valid_from: null,
    valid_until: null,
    agency_agreement_type: 0,
    agreement_method: null,
    additionalProperties: {
      business_opportunity_knowledge_date: null,
    },
  },
  additionalProperties: {
    room_layout: 'centrally_accessible',
    preview_plan: {
      storage_key: [],
      sizes: [[[]], [[]], [[]]],
    },
    year_of_last_comprehensive_renovation: null,
    realty_condition: null,
    building_condition: null,
    vendor_economic_relationship: null,
    dual_brokerage: null,
    automatic_hits: true,
    land_register_entries: [],
    ownership_type: null,
    furnishing: null,
    noise_level: null,
    location_assessment: null,
    floors: {
      count_floors: [],
      count_attic_floors: [],
      mezzanine: [],
    },
  },
};

export const similarImmo5Categories = {
  groups: [
    {
      id: 'traffic',
      name: 'Verkehr',
      categories: [
        {
          id: 'bus',
          name: 'Bus',
          distance: 166,
          additionalProperties: {},
        },
        {
          id: 'railway_station',
          name: 'Bahnhof',
          distance: 244,
          additionalProperties: {},
        },
        {
          id: 'motorway_junction',
          name: 'Autobahnanschluss',
          distance: 1893,
          additionalProperties: {},
        },
        {
          id: 'tram',
          name: 'Straßenbahn',
          distance: 1580,
          additionalProperties: {},
        },
        {
          id: 'aerodrome',
          name: 'Flughafen',
          distance: 6140,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'health',
      name: 'Gesundheit',
      categories: [
        {
          id: 'doctors',
          name: 'Arzt',
          distance: 245,
          additionalProperties: {},
        },
        {
          id: 'pharmacy',
          name: 'Apotheke',
          distance: 423,
          additionalProperties: {},
        },
        {
          id: 'clinic',
          name: 'Klinik',
          distance: 3380,
          additionalProperties: {},
        },
        {
          id: 'hospital',
          name: 'Krankenhaus',
          distance: 3016,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'children_and_school',
      name: 'Kinder & Schulen',
      categories: [
        {
          id: 'school',
          name: 'Schule',
          distance: 246,
          additionalProperties: {},
        },
        {
          id: 'kindergarten',
          name: 'Kindergarten',
          distance: 69,
          additionalProperties: {},
        },
        {
          id: 'college',
          name: 'Höhere Schule',
          distance: 6087,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'other',
      name: 'Sonstige',
      categories: [
        {
          id: 'bank',
          name: 'Bank',
          distance: 312,
          additionalProperties: {},
        },
        {
          id: 'atm',
          name: 'Geldautomat',
          distance: 312,
          additionalProperties: {},
        },
        {
          id: 'police',
          name: 'Polizei',
          distance: 197,
          additionalProperties: {},
        },
        {
          id: 'post_office',
          name: 'Post',
          distance: 579,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'local_supply',
      name: 'Nahversorgung',
      categories: [
        {
          id: 'supermarket',
          name: 'Supermarkt',
          distance: 328,
          additionalProperties: {},
        },
        {
          id: 'bakery',
          name: 'Bäckerei',
          distance: 235,
          additionalProperties: {},
        },
        {
          id: 'mall',
          name: 'Einkaufszentrum',
          distance: 904,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  additionalProperties: {},
};

export const similarImmo5 = {
  id: 'OBGC202504150809345e0wub2g',
  tree_info: {
    name: 'simple',
  },
  crm_id: '14616810',
  number: '960/71792',
  sreal_type_id: 'haus',
  sreal_sub_type_id: 3,
  tenant_id: 960,
  title: {
    de: 'Traumhaus in Traiskirchen: 4 Zimmer, Garage, modernste Ausstattung',
    en: null,
  },
  address: {
    zip: '2514',
    city: 'Traiskirchen',
    federal_state: 'Niederösterreich',
    district: null,
    country: 'AUT',
    street: '',
    door_number: null,
    stair: null,
    house_number: '',
    floor: null,
  },
  buyable: true,
  rentable: false,
  price: {
    currency: 'EUR',
    commission: {
      obligated: true,
      text: {
        de: '',
      },
    },
    garage: {
      count: 1,
    },
    purchase: {
      gross: 504000,
    },
    from: 504000,
    to: 504000,
  },
  area: {
    living: 98,
    floor: 98,
    surface: 0,
    cellar: 0,
    from: 98,
    to: 98,
  },
  rooms: 4,
  cover_image: {
    url: 'https://storage.justimmo.at/thumb/d085e4e972c399edaab3c5bf03fd42c2/fc_h1080_w1920/5yN157ga9P7qtMPrmckYlS.jpg',
  },
  tags: {
    tour: false,
    exclusive: false,
    reference: false,
    residential: true,
    commercial: false,
  },
  project_data: null,
};
